import { Component,ElementRef, HostListener, Input, NgZone, OnInit, ViewChild  } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MessService } from '../mess.service';
import moment from 'moment';
import { CellValueChangedEvent, ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { AddItemDialogComponent } from '../add-item-dialog/add-item-dialog.component';
import { ApplyHolidayComponent } from '../apply-holiday/apply-holiday.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { SupplyBuildingDialogComponent } from '../supply-building-dialog/supply-building-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { HolidayReasonViewDialogComponent } from '../holiday-reason-view-dialog/holiday-reason-view-dialog.component';
import {
  MenuAllowedMeals,
  MenuDialogComponent,
  MenuDialogSubmitResult,
  ScenarioBasedMenuItemPayload,
} from '../menu-dialog/menu-dialog.component';
import { MessSummaryDialogComponent } from '../mess-summary-dialog/mess-summary-dialog.component';
import { DaysheetcloseConfirmationMessageDialogComponent } from '../daysheetclose-confirmation-message-dialog/daysheetclose-confirmation-message-dialog.component';
import { ConfirmationMessageDialogComponent } from '../confirmation-message-dialog/confirmation-message-dialog.component';
import { AdminMenuDialogComponent } from '../admin-menu-dialog/admin-menu-dialog.component';
import { AdminSingleAdditemComponent } from '../admin-single-additem/admin-single-additem.component';
import { DataStoreService } from '../data-store.service';


const MEAL_QTY_FIELDS = ['bfQty', 'lunchQty', 'snacksQty', 'DinnerQty'] as const;
type MealQtyField = (typeof MEAL_QTY_FIELDS)[number];

export interface PeriodicElement2 {
  itemName: string;
  teluguItemName: string;
  itemFusionId: string;
  openBalance: any;
  totalQty: any;
  bfQty: any;
  lunchQty: any;
  snacksQty: any;
  DinnerQty: any;
  ratePerUnit: any;
  totalAmount: any;
  closedBalance: any;
  itemId: any;
  itemStatus?: string;
}

@Component({
  selector: 'app-admin-mess-inventory',
  templateUrl: './admin-mess-inventory.component.html',
  styleUrls: ['./admin-mess-inventory.component.scss']
})
export class AdminMessInventoryComponent implements OnInit {

  
  // ✅ fires when tab/browser closes or refreshes
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = ''; // ✅ required for Chrome
    return 'Are you sure you want to leave? Changes may not be saved.';
  }

  /**
   * Latest date allowed in the Stock Date picker: today.
   * (Specific days are enabled/disabled by `messInventoryDateFilter`.)
   */
  get maxStockDate(): moment.Moment {
    return moment().startOf('day');
  }

  /**
   * First PENDING row from messReport.
   * Dates after this are selectable only if they are CLOSED in the response.
   */
  private pendingDaysheetMoment: moment.Moment | null = null;
  /** Number of PENDING rows from messReport (1 = allow +1 day; 2+ = cap at latest pending only). */
  private pendingDaysheetCount = 0;
  /** Latest CLOSED daysheet date from messReport (used to allow only next 1 day). */
  private lastClosedDaysheetMoment: moment.Moment | null = null;
  /** Status of the latest (max) daysheetDate returned by messReport. */
  private latestDaysheetStatus: 'PENDING' | 'CLOSED' | 'CLOSE' | '' = '';

  current = new Date();
  /** Bound to Stock Date picker (Moment for Material moment-adapter). */
  stockPickerDate: moment.Moment | null = null;
  @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;
  campusQuery: string = '';
  KitchenType: any = '';
  selectDate: string = '';
  messDate: any;
  allocatedCampusList: any;
  filteredCampusDetails: any;
  selectedBuildingName: any;
  selectedBuildingID: any;
  buildingValue: any;
  quickFilter: string = '';
  MealsType: string = '';
  userbuildingId: any;
  /** Item Name column: English vs Telugu label (data still has both fields). */
  itemNameDisplayLang: 'en' | 'te' = 'en';
  inventroyData: any;
  /** Daysheet date key last applied from `getInventoryDetails` merge (avoids stale status). */
  private lastInventoryDetailsDate = '';
  gridApi!: GridApi;

  // ✅ Store total amount
  totalAmountValue: number = 0;

  /** When daysheet is closed, Submit Daysheet must stay disabled. */
  isDaysheetSubmitDisabled = false;

  /** Toggle panel below submit row showing daysheet summary from current form state. */
  showTotalSummary = false;
  totalSummaryData: any = null;
  /** Expand/collapse state for total-summary scenario tables (Breakfast expanded by default). */
  private summaryScenarioExpanded: Record<string, boolean> = {};
  /** Total summary view toggle: 'all' shows Today's Menu + merged table, 'summary' shows per-scenario boxes. */
  summaryViewMode: 'all' | 'summary' = 'all';
  allSummaryRows: any[] = [];
  allSummaryTotalCost = 0;

  daysheetStatus: string = '';
  private daysheetStatusByDate = new Map<string, string>();
  /** messReport-only statuses used for datepicker coloring (excludes allowed +1 days). */
  private daysheetReportStatusByDate = new Map<string, string>();
  /** Per daysheetDate: holiday flag and reason from messReport. */
  private daysheetHolidayByDate = new Map<string, { holiday: boolean; holidayReason: string }>();
  /** After messReport succeeds; enables strict date filter vs API-only dates. */
  private daysheetReportLoaded = false;
  /** messReport `next` with no body (e.g. HTTP 204): stock picker allows today and past only. */
  private daysheetReportNoContent = false;

  userbuildingName = '';

  /** Used by Angular Material datepicker to color dates based on status. */
  daysheetDateClass = (date: Date): string => {
    const key = moment(date).format('DD MMM YYYY');
    const hol = this.daysheetHolidayByDate.get(key);
    if (hol?.holiday === true) {
      return 'daysheet-holiday date-holiday';
    }
    const status = String(this.daysheetReportStatusByDate.get(key) ?? '').trim().toUpperCase();
    if (status === 'PENDING') return 'daysheet-pending date-pending';
    if (status === 'CLOSED' || status === 'CLOSE') return 'daysheet-close date-close';
    return '';
  };

  private getTodayStart(): moment.Moment {
    return moment().startOf('day');
  }

  private getPendingDateFilterBounds(today: moment.Moment): {
    pendingDay: moment.Moment;
    allowNextDay: boolean;
    cap: moment.Moment;
  } | null {
    if (!this.pendingDaysheetMoment?.isValid() || !this.shouldApplyPendingDateFilter()) {
      return null;
    }
    const pendingDay = this.pendingDaysheetMoment.clone().startOf('day');
    const allowNextDay = this.pendingDaysheetCount === 1 && !pendingDay.isSame(today, 'day');
    const cap = allowNextDay ? pendingDay.clone().add(1, 'day') : pendingDay;
    return { pendingDay, allowNextDay, cap };
  }

  private getClosedDateFilterBounds(today: moment.Moment): {
    closedDay: moment.Moment;
    allowNextDay: boolean;
    cap: moment.Moment;
  } | null {
    if (!this.lastClosedDaysheetMoment?.isValid() || !this.shouldApplyClosedDateFilter()) {
      return null;
    }
    const closedDay = this.lastClosedDaysheetMoment.clone().startOf('day');
    const allowNextDay = !closedDay.isSame(today, 'day');
    const cap = allowNextDay ? closedDay.clone().add(1, 'day') : closedDay;
    return { closedDay, allowNextDay, cap };
  }

  /** Use PENDING cap rules only when latest messReport status (or date) is PENDING. */
  private shouldApplyPendingDateFilter(): boolean {
    if (!this.pendingDaysheetMoment?.isValid()) {
      return false;
    }
    const latest = String(this.latestDaysheetStatus ?? '').trim().toUpperCase();
    if (latest === 'PENDING') {
      return true;
    }
    if (latest === 'CLOSED' || latest === 'CLOSE') {
      return false;
    }
    if (this.lastClosedDaysheetMoment?.isValid()) {
      return this.pendingDaysheetMoment.isAfter(this.lastClosedDaysheetMoment, 'day');
    }
    return true;
  }

  /** Use CLOSED + next-day rules when latest messReport status (or date) is CLOSED. */
  private shouldApplyClosedDateFilter(): boolean {
    if (!this.lastClosedDaysheetMoment?.isValid()) {
      return false;
    }
    const latest = String(this.latestDaysheetStatus ?? '').trim().toUpperCase();
    if (latest === 'CLOSED' || latest === 'CLOSE') {
      return true;
    }
    if (latest === 'PENDING') {
      return false;
    }
    if (this.pendingDaysheetMoment?.isValid()) {
      return this.lastClosedDaysheetMoment.isAfter(this.pendingDaysheetMoment, 'day');
    }
    return true;
  }

  /** Same guard as itemName click / openItemQtyDialog — closed daysheet or holiday date. */
  private isInventoryGridReadOnly(): boolean {
    return this.isDaysheetSubmitDisabled || this.isHolidayBlockingActions();
  }

  hasActiveMenuSelection(): boolean {
    return this.hasActiveMenuInScenarioList(this.scenarioBasedMenuItemsList);
  }

  private hasActiveMenuInScenarioList(list: ScenarioBasedMenuItemPayload[]): boolean {
    return (list ?? []).some((scenario) =>
      (scenario.daysheetMenuItemsList ?? []).some((item) => String(item.status ?? '1') !== '0'),
    );
  }

  private getActiveStockDate(): string {
    return (
      String(this.selectDate ?? '').trim() ||
      String(this.lastInventoryDetailsDate ?? '').trim() ||
      moment(this.current).format('DD MMM YYYY')
    );
  }

  private isMenuCardSubmittedForCurrentDate(): boolean {
    const date = this.getActiveStockDate();
    return !!date && this.menuCardSubmittedForDate === date;
  }

  private emptyMenuAllowedMeals(): MenuAllowedMeals {
    return { breakfast: false, lunch: false, snacks: false, dinner: false };
  }

  private getMealKeyFromScenarioName(name: string): keyof MenuAllowedMeals | null {
    const n = String(name ?? '').trim().toLowerCase();
    if (n.includes('breakfast')) {
      return 'breakfast';
    }
    if (n.includes('lunch')) {
      return 'lunch';
    }
    if (n.includes('snack')) {
      return 'snacks';
    }
    if (n.includes('dinner')) {
      return 'dinner';
    }
    return null;
  }

  private getMealKeyFromQtyField(field: MealQtyField): keyof MenuAllowedMeals | null {
    const map: Record<MealQtyField, keyof MenuAllowedMeals> = {
      bfQty: 'breakfast',
      lunchQty: 'lunch',
      snacksQty: 'snacks',
      DinnerQty: 'dinner',
    };
    return map[field] ?? null;
  }

  private applyMenuAllowedMealsFromScenarios(list: ScenarioBasedMenuItemPayload[]): void {
    const flags = this.emptyMenuAllowedMeals();
    const scenarioIds = new Set<number>();
    (list ?? []).forEach((scenario) => {
      const hasActive = (scenario.daysheetMenuItemsList ?? []).some(
        (item) => String(item.status ?? '1') !== '0',
      );
      if (!hasActive) {
        return;
      }
      const scenarioId = Number(scenario.scenarioId);
      if (Number.isFinite(scenarioId)) {
        scenarioIds.add(scenarioId);
      }
      const key = this.getMealKeyFromScenarioName(scenario.scenarioName);
      if (key) {
        flags[key] = true;
      }
    });
    this.menuAllowedMeals = flags;
    this.menuAllowedScenarioIds = scenarioIds;
  }

  private hasAnyAllowedMealScenario(): boolean {
    return Object.values(this.menuAllowedMeals).some(Boolean);
  }

  private syncMenuCardSubmittedForDateFromInventory(): void {
    const dateKey = this.getActiveStockDate();
    if (!dateKey) {
      return;
    }
    const inv = this.inventroyData;
    const scenarioList = inv ? this.getScenarioBasedMenuItemsListFromInventory(inv) : [];
    const hasSavedMenu = scenarioList.some((scenario: any) =>
      (Array.isArray(scenario?.daysheetMenuItemsList) ? scenario.daysheetMenuItemsList : []).some(
        (item: any) => String(item?.status ?? '1') !== '0',
      ),
    );
    if (hasSavedMenu) {
      this.menuCardSubmittedForDate = dateKey;
      if (!this.menuAllowedMealsLockedFromSubmit) {
        this.applyMenuAllowedMealsFromScenarios(
          this.normalizeScenarioBasedMenuItemsList(scenarioList),
        );
      }
      return;
    }
    if (this.menuCardSubmittedForDate === dateKey && !this.hasActiveMenuSelection()) {
      this.menuCardSubmittedForDate = '';
      this.menuAllowedMeals = this.emptyMenuAllowedMeals();
      this.menuAllowedScenarioIds.clear();
      this.menuAllowedMealsLockedFromSubmit = false;
    }
  }

  /** Regular inventory grid loads only after Menu Card Submit for allowed meal scenarios. */
  isRegularItemsAllowed(): boolean {
    if (this.isInventoryGridReadOnly()) {
      return true;
    }
    if (!this.isMenuCardSubmittedForCurrentDate()) {
      return false;
    }
    return this.hasAnyAllowedMealScenario();
  }

  private findScenarioForMealQtyField(field: MealQtyField): ScenarioBasedMenuItemPayload | null {
    const matchers: Record<MealQtyField, string[]> = {
      bfQty: ['breakfast'],
      lunchQty: ['lunch'],
      snacksQty: ['snack'],
      DinnerQty: ['dinner'],
    };
    const keys = matchers[field];
    return (
      (this.scenarioBasedMenuItemsList ?? []).find((scenario) => {
        const name = String(scenario.scenarioName ?? '').trim().toLowerCase();
        return keys.some((key) => name.includes(key));
      }) ?? null
    );
  }

  private isMealScenarioMenuConfigured(scenario: ScenarioBasedMenuItemPayload | null): boolean {
    if (!scenario) {
      return false;
    }
    return (scenario.daysheetMenuItemsList ?? []).some((item) => String(item.status ?? '1') !== '0');
  }

  isMealQtyInputEnabled(field: MealQtyField): boolean {
    if (this.isInventoryGridReadOnly()) {
      return false;
    }
    if (!this.isMenuCardSubmittedForCurrentDate()) {
      return false;
    }
    const scenario = this.findScenarioForMealQtyField(field);
    if (scenario && this.menuAllowedScenarioIds.has(Number(scenario.scenarioId))) {
      return true;
    }
    const mealKey = this.getMealKeyFromQtyField(field);
    return !!mealKey && this.menuAllowedMeals[mealKey];
  }

  private applyMenuSubmitAccess(res: MenuDialogSubmitResult): void {
    this.menuAllowedMeals = res.allowedMealScenarios
      ? { ...res.allowedMealScenarios }
      : this.emptyMenuAllowedMeals();
    this.menuAllowedScenarioIds = new Set(
      (res.allowedScenarioIds ?? [])
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id)),
    );
    if (!this.menuAllowedScenarioIds.size) {
      (res.scenarioBasedMenuItemsList ?? []).forEach((scenario) => {
        const hasActive = (scenario.daysheetMenuItemsList ?? []).some(
          (item) => String(item.status ?? '1') !== '0',
        );
        if (!hasActive) {
          return;
        }
        const scenarioId = Number(scenario.scenarioId);
        if (Number.isFinite(scenarioId)) {
          this.menuAllowedScenarioIds.add(scenarioId);
        }
      });
    }
    if (!this.hasAnyAllowedMealScenario()) {
      this.applyMenuAllowedMealsFromScenarios(res.scenarioBasedMenuItemsList ?? []);
    }
    this.menuAllowedMealsLockedFromSubmit = true;
  }

  private mergeSubmittedScenarioMenuList(
    current: ScenarioBasedMenuItemPayload[],
    submitted: ScenarioBasedMenuItemPayload[],
  ): ScenarioBasedMenuItemPayload[] {
    const byId = new Map<number, ScenarioBasedMenuItemPayload>();
    (current ?? []).forEach((scenario) => {
      const id = Number(scenario.scenarioId);
      if (Number.isFinite(id)) {
        byId.set(id, scenario);
      }
    });
    (submitted ?? []).forEach((scenario) => {
      const id = Number(scenario.scenarioId);
      if (!Number.isFinite(id)) {
        return;
      }
      const existing = byId.get(id);
      byId.set(id, {
        ...existing,
        ...scenario,
        scenarioId: scenario.scenarioId,
        scenarioName: scenario.scenarioName,
        daysheetMenuItemsList: this.mergeDaysheetMenuItemsById(
          existing?.daysheetMenuItemsList ?? [],
          scenario.daysheetMenuItemsList ?? [],
        ),
        saveInventoryBalanceDetails:
          scenario.saveInventoryBalanceDetails ?? existing?.saveInventoryBalanceDetails ?? [],
      });
    });
    return Array.from(byId.values());
  }

  /** Merge menu items by id so additional selections accumulate across menu-card submits. */
  private mergeDaysheetMenuItemsById(
    existing: { daysheetMenuItemId: number; daysheetMenuItemName: string; status?: string; itemStatus?: string }[],
    submitted: { daysheetMenuItemId: number; daysheetMenuItemName: string; status?: string; itemStatus?: string }[],
  ): { daysheetMenuItemId: number; daysheetMenuItemName: string; status?: string; itemStatus?: string }[] {
    const byId = new Map<number, (typeof existing)[number]>();
    (existing ?? []).forEach((item) => {
      const id = Number(item.daysheetMenuItemId);
      if (Number.isFinite(id)) {
        byId.set(id, item);
      }
    });
    (submitted ?? []).forEach((item) => {
      const id = Number(item.daysheetMenuItemId);
      if (!Number.isFinite(id)) {
        return;
      }
      const prev = byId.get(id);
      byId.set(id, prev ? { ...prev, ...item } : item);
    });
    return Array.from(byId.values());
  }

  /** Keep locally submitted menu names when API inventory details are still stale. */
  private mergeScenarioMenuListsPreservingLocalMenu(
    local: ScenarioBasedMenuItemPayload[],
    fromApi: ScenarioBasedMenuItemPayload[],
  ): ScenarioBasedMenuItemPayload[] {
    const localById = new Map<number, ScenarioBasedMenuItemPayload>();
    (local ?? []).forEach((scenario) => {
      const id = Number(scenario.scenarioId);
      if (Number.isFinite(id)) {
        localById.set(id, scenario);
      }
    });
    const apiById = new Map<number, ScenarioBasedMenuItemPayload>();
    (fromApi ?? []).forEach((scenario) => {
      const id = Number(scenario.scenarioId);
      if (Number.isFinite(id)) {
        apiById.set(id, scenario);
      }
    });
    const allIds = new Set([...localById.keys(), ...apiById.keys()]);
    return Array.from(allIds)
      .sort((a, b) => a - b)
      .map((scenarioId) => {
        const localScenario = localById.get(scenarioId);
        const apiScenario = apiById.get(scenarioId);
        if (!localScenario) {
          return apiScenario!;
        }
        if (!apiScenario) {
          return localScenario;
        }
        const localMenu = localScenario.daysheetMenuItemsList ?? [];
        const apiMenu = apiScenario.daysheetMenuItemsList ?? [];
        return {
          ...apiScenario,
          ...localScenario,
          scenarioId: localScenario.scenarioId,
          scenarioName: localScenario.scenarioName || apiScenario.scenarioName,
          daysheetMenuItemsList: localMenu.length
            ? this.mergeDaysheetMenuItemsById(apiMenu, localMenu)
            : apiMenu,
          saveInventoryBalanceDetails:
            apiScenario.saveInventoryBalanceDetails?.length
              ? apiScenario.saveInventoryBalanceDetails
              : localScenario.saveInventoryBalanceDetails ?? [],
        };
      });
  }

  private syncMealColumnAccessFromMenu(): void {
    if (!this.isMenuCardSubmittedForCurrentDate() || this.menuAllowedMealsLockedFromSubmit) {
      return;
    }
    this.applyMenuAllowedMealsFromScenarios(this.scenarioBasedMenuItemsList);
  }

  private loadRegularItemsIfAllowed(): void {
    if (this.isRegularItemsAllowed()) {
      this.ItemList();
      return;
    }
    this.rowData = [];
    this.updatePinnedBottomRow();
    this.gridApi?.setGridOption?.('rowData', this.rowData as any);
    this.showInventoryNoRowsOverlay();
    this.refreshInventoryEditableCells();
  }

  /** Stock date is a reported holiday — block submit / item edits like a closed daysheet. */
  isHolidayBlockingActions(): boolean {
    const key = String(this.selectDate ?? '').trim();
    if (!key) {
      return false;
    }
    return this.daysheetHolidayByDate.get(key)?.holiday === true;
  }

  /** Earliest selectable holiday date from messReport / current stock date. */
  private getHolidayMinSelectableDate(): Date {
    const key = String(this.selectDate ?? '').trim();
    if (key) {
      const parsed = moment(key, 'DD MMM YYYY', true);
      if (parsed.isValid()) {
        return parsed.startOf('day').toDate();
      }
    }
    const defaultStock = this.resolveDefaultStockDateFromReport();
    if (defaultStock?.stockPickerDate?.isValid()) {
      return defaultStock.stockPickerDate.clone().startOf('day').toDate();
    }
    return moment().startOf('day').toDate();
  }

  /**
   * After messReport loads: only dates returned by the API (CLOSED/PENDING rows), plus today,
   * are selectable — so e.g. May 3 stays disabled unless present in the response.
   * Before load: keep previous behaviour (any date up to today, capped by [max]).
   * When messReport returns no body (`!res`, e.g. 204): today and past selectable; future dates disabled.
   */

  // messInventoryDateFilter = (date: Date | null): boolean => {
  //   if (!date) return false;
  //   const d = moment(date).startOf('day');
  //   const key = d.format('DD MMM YYYY');

  //   if (!this.daysheetReportLoaded) {
  //     return true;
  //   }

  //   if (this.daysheetReportNoContent) {
  //     const today = moment().startOf('day');
  //     return !d.isAfter(today, 'day');
  //   }

  //   const isInApiMap = this.daysheetStatusByDate.has(key);

  //   // Hard cap date:
  //   // - If PENDING exists: cap = pending day (everything after pending disabled)
  //   // - Else if CLOSED exists: cap = last CLOSED + 1 day (only that next day enabled)
  //   // This logic does NOT use the system current date.
  //   const cap = this.pendingDaysheetMoment?.isValid()
  //     ? this.pendingDaysheetMoment.clone().startOf('day')
  //     : (this.lastClosedDaysheetMoment?.isValid()
  //       ? this.lastClosedDaysheetMoment.clone().startOf('day').add(1, 'day')
  //       : null);

  //   if (cap && d.isAfter(cap, 'day')) {
  //     return false;
  //   }

  //   // Always allow the cap day itself (even if not present in API map).
  //   if (cap && d.isSame(cap, 'day')) {
  //     return true;
  //   }

  //   // Otherwise allow only dates explicitly returned by the API map.
  //   return isInApiMap;
  // };



  // supplyBuilding//

  // messInventoryDateFilter = (date: Date | null): boolean => {
  //   if (!date) return false;
  //   const d = moment(date).startOf('day');
  //   const key = d.format('DD MMM YYYY');

  //   if (!this.daysheetReportLoaded) {
  //     return true;
  //   }

  //   if (this.daysheetReportNoContent) {
  //     const today = moment().startOf('day');
  //     return !d.isAfter(today, 'day');
  //   }

  //   const isInApiMap = this.daysheetStatusByDate.has(key);

  //   // ✅ PENDING: allow pendingDay, pendingDay+1, pendingDay+2
  //   if (this.pendingDaysheetMoment?.isValid()) {
  //     const pendingDay = this.pendingDaysheetMoment.clone().startOf('day');
  //     const pendingPlus1 = pendingDay.clone().add(1, 'day');
  //     const pendingPlus2 = pendingDay.clone().add(2, 'day');

  //     // Hard cap: disable everything after pendingDay + 2
  //     if (d.isAfter(pendingPlus2, 'day')) {
  //       return false;
  //     }

  //     // Allow the 3-day window: pendingDay, pendingDay+1, pendingDay+2
  //     if (
  //       d.isSame(pendingDay, 'day') ||
  //       d.isSame(pendingPlus1, 'day') ||
  //       d.isSame(pendingPlus2, 'day')
  //     ) {
  //       return true;
  //     }
  //   }

  //   // ✅ CLOSED: allow lastClosed+1 and lastClosed+2
  //   if (this.lastClosedDaysheetMoment?.isValid()) {
  //     const closedPlus1 = this.lastClosedDaysheetMoment.clone().startOf('day').add(1, 'day');
  //     const closedPlus2 = this.lastClosedDaysheetMoment.clone().startOf('day').add(2, 'day');

  //     // Hard cap: disable everything after closed + 2
  //     if (d.isAfter(closedPlus2, 'day')) {
  //       return false;
  //     }

  //     // Allow the 2-day window: closed+1 and closed+2
  //     if (d.isSame(closedPlus1, 'day') || d.isSame(closedPlus2, 'day')) {
  //       return true;
  //     }
  //   }

  //   // Otherwise allow only dates explicitly returned by the API map.
  //   return isInApiMap;
  // };

  messInventoryDateFilter = (date: Date | null): boolean => {
    if (!date) return false;
    const d = moment(date).startOf('day');
    const key = d.format('DD MMM YYYY');
    const today = this.getTodayStart();

    if (!this.daysheetReportLoaded) {
      return true;
    }

    if (this.daysheetReportNoContent) {
      return !d.isAfter(today, 'day');
    }

    const isInApiMap = this.daysheetStatusByDate.has(key);

    // Current date and future dates are never selectable.
    if (d.isAfter(today, 'day')) {
      return false;
    }

    // PENDING:
    // - 2+ pending days: latest pending only (no next day).
    // - 1 pending day: allow next day unless that pending day is today.
    const pending = this.getPendingDateFilterBounds(today);
    if (pending) {
      if (d.isAfter(pending.cap, 'day')) {
        return false;
      }

      if (d.isSame(pending.pendingDay, 'day')) {
        return true;
      }

      if (pending.allowNextDay && d.isSame(pending.pendingDay.clone().add(1, 'day'), 'day')) {
        return true;
      }
    }

    // CLOSED: allow last closed day and next day unless last closed day is today.
    const closed = this.getClosedDateFilterBounds(today);
    if (closed) {
      if (d.isAfter(closed.cap, 'day')) {
        return isInApiMap;
      }

      if (d.isSame(closed.closedDay, 'day')) {
        return true;
      }

      if (closed.allowNextDay && d.isSame(closed.closedDay.clone().add(1, 'day'), 'day')) {
        return true;
      }
    }

    // Otherwise allow only dates explicitly in the API map.
    return isInApiMap;
  };

  /**
   * Default stock date after messReport: next allowed day after latest PENDING/CLOSED
   * (same rules as messInventoryDateFilter), capped at today.
   */
  private resolveDefaultStockDateFromReport(): { selectDate: string; stockPickerDate: moment.Moment } | null {
    const today = this.getTodayStart();

    const pending = this.getPendingDateFilterBounds(today);
    if (pending) {
      let defaultDay = pending.allowNextDay ? pending.pendingDay.clone().add(1, 'day') : pending.pendingDay;
      if (defaultDay.isAfter(today, 'day')) {
        defaultDay = today.clone();
      }
      return {
        selectDate: defaultDay.format('DD MMM YYYY'),
        stockPickerDate: defaultDay.clone(),
      };
    }

    const closed = this.getClosedDateFilterBounds(today);
    if (closed) {
      let defaultDay = closed.allowNextDay ? closed.closedDay.clone().add(1, 'day') : closed.closedDay;
      if (defaultDay.isAfter(today, 'day')) {
        defaultDay = today.clone();
      }
      return {
        selectDate: defaultDay.format('DD MMM YYYY'),
        stockPickerDate: defaultDay.clone(),
      };
    }

    return null;
  }

  BuildingDetails: any[] = [];
  scenarioBasedMenuItemsList: ScenarioBasedMenuItemPayload[] = [];
  /** Stock date for which Menu Card Submit was clicked (unlocks regularItems). */
  private menuCardSubmittedForDate = '';
  /** Stock date for which Supply Building dialog was submitted this session. */
  private supplyBuildingSubmittedForDate = '';
  /** Meal scenarios allowed after Menu Card Submit (Breakfast / Lunch / Snacks / Dinner). */
  private menuAllowedMeals: MenuAllowedMeals = {
    breakfast: false,
    lunch: false,
    snacks: false,
    dinner: false,
  };
  /** Keep meal-column flags from menu Submit until API saved menu or date change. */
  private menuAllowedMealsLockedFromSubmit = false;
  /** Scenario ids with active menu items after Menu Card Submit. */
  private menuAllowedScenarioIds = new Set<number>();
  currentDate: any;
  // supplyBuilding//

  constructor(
    private service: MessService,
    private spinner: NgxSpinnerService,
    private toast: ToastmessageService,
    private dialog: NgDialogAnimationService,
    private matDialog: MatDialog,
    private zone: NgZone,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private dataStore: DataStoreService,
  ) {
    this.current = new Date();
  }

  toggleHolidayCard(): void {
    const dialogRef = this.dialog.open(ApplyHolidayComponent, {
      width: '30%',
      height: '100%',
      data: {
        messBuildingId: this.userbuildingId,
        minHolidayDate: this.getHolidayMinSelectableDate(),
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((res: unknown) => {
      if (res) {
        this.loadDaysheetStatus();
      }
    });
  }

  ngOnInit(): void {
    // Landing shell (MessDetails): params from MessService after division → inventory setView
    if (this.router.url.includes('MessDetails')) {
      const fromService = this.service.getAdminMessInventoryParams();
      if (fromService?.['messBuildingId'] && fromService?.['daysheetDate']) {
        this.applyInventoryParams(fromService);
        return;
      }
      this.toast.showError('Building and daysheet date are required.');
      this.service.clearAdminMessInventoryParams();
      this.service.setView('adminDivisionReport');
      return;
    }

    // Dedicated /adminMessInventory route: keep existing queryParams behavior
    this.route.queryParams.subscribe((params) => {
      const messBuildingId = params['messBuildingId'];
      const daysheetDate = String(params['daysheetDate'] ?? '').trim();
      const messBuildingName = String(params['messBuildingName'] ?? '').trim();

      if (!messBuildingId || !daysheetDate) {
        this.toast.showError('Building and daysheet date are required.');
        this.router.navigate(['/adminDashboard']);
        return;
      }

      this.applyInventoryParams({
        messBuildingId,
        daysheetDate,
        messBuildingName,
      });
    });
  }

  private applyInventoryParams(params: Record<string, any>): void {
    const messBuildingId = params['messBuildingId'];
    const daysheetDate = String(params['daysheetDate'] ?? '').trim();
    const messBuildingName = String(params['messBuildingName'] ?? '').trim();

    this.userbuildingId = messBuildingId;
    this.userbuildingName = messBuildingName;
    this.selectDate = daysheetDate;
    const parsed = moment(daysheetDate, 'DD MMM YYYY', true);
    this.stockPickerDate = parsed.isValid() ? parsed : moment(daysheetDate);
    this.getInventoryDetails();
  }

  onStockDateChange(event: any) {
    const v = event?.value;
    const m = v != null ? moment(v) : null;
    this.stockPickerDate = m?.isValid() ? m : null;
    const nextDate = m?.isValid() ? m.format('DD MMM YYYY') : '';
    if (nextDate && this.menuCardSubmittedForDate && this.menuCardSubmittedForDate !== nextDate) {
      this.menuCardSubmittedForDate = '';
      this.scenarioBasedMenuItemsList = [];
      this.menuAllowedMeals = this.emptyMenuAllowedMeals();
      this.menuAllowedScenarioIds.clear();
      this.menuAllowedMealsLockedFromSubmit = false;
    }
    if (nextDate && this.supplyBuildingSubmittedForDate && this.supplyBuildingSubmittedForDate !== nextDate) {
      this.supplyBuildingSubmittedForDate = '';
      this.BuildingDetails = [];
    }
    this.selectDate = nextDate;
    this.getInventoryDetails();
  }

  getuserBuilding() {
    this.spinner.show();
    this.service.userBuildings().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.userbuildingId = res[0].buidingId;
        this.userbuildingName = res[0].buildingName;
        console.log('this.userbuildingId', this.userbuildingId);
        this.loadDaysheetStatus();
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  getInventoryDetails() {
    if (!this.userbuildingId) {
      return;
    }
    const daySheetDate = String(this.selectDate ?? '').trim();
    if (!daySheetDate) {
      return;
    }
    this.spinner.show();
    this.isDaysheetSubmitDisabled = false;
    this.inventroyData = null;
    this.lastInventoryDetailsDate = '';
    this.service.adminMessInventory(this.userbuildingId, daySheetDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.inventroyData = null;
          this.isDaysheetSubmitDisabled = false;
          this.lastInventoryDetailsDate = '';
          this.scenarioBasedMenuItemsList = [];
          this.menuAllowedMeals = this.emptyMenuAllowedMeals();
          this.menuAllowedScenarioIds.clear();
          this.menuAllowedMealsLockedFromSubmit = false;
          this.spinner.hide();
          return;
        }
        this.inventroyData = res;
        this.lastInventoryDetailsDate = daySheetDate;
        this.applyInventoryMetaFromServer();
        this.loadRegularItemsIfAllowed();
        console.log('this.inventroyData', this.inventroyData);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.inventroyData = null;
        this.isDaysheetSubmitDisabled = false;
        this.lastInventoryDetailsDate = '';
        this.scenarioBasedMenuItemsList = [];
        this.menuAllowedMeals = this.emptyMenuAllowedMeals();
        this.menuAllowedScenarioIds.clear();
        this.menuAllowedMealsLockedFromSubmit = false;
        this.spinner.hide();
      }
    })
  }

  private refreshMealQtyGridCells(): void {
    this.zone.run(() => {
      if (!this.gridApi) {
        return;
      }
      this.gridApi.redrawRows();
      requestAnimationFrame(() => {
        this.syncMealQtyInputsInDom();
        requestAnimationFrame(() => this.syncMealQtyInputsInDom());
      });
    });
  }

  private isClosedDaySheetStatus(status: any): boolean {
    const s = String(status ?? '').trim().toUpperCase();
    return s === 'CLOSED' || s === 'CLOSE';
  }

  /**
   * After regularItems loads rowData, merge getInventoryDetails payload:
   * - PENDING (or any non-closed): bind saveInventoryBalanceDetails into rows; apply supplyBuildings when present.
   * - CLOSED/CLOSE: disable submit; still bind values for read-only view.
   * - ScenarioBasedMenuItemsList: bind menu selections and per-scenario inventory rows.
   */
  private applyInventoryMetaFromServer(): void {
    const inv = this.inventroyData;
    if (!inv || typeof inv !== 'object') {
      this.isDaysheetSubmitDisabled = false;
      if (!this.hasActiveMenuSelection()) {
        this.scenarioBasedMenuItemsList = [];
      }
      return;
    }

    const statusRaw = inv.status;
    this.daysheetStatus = String(statusRaw ?? '').trim();
    this.isDaysheetSubmitDisabled = false;

    const dateKey = this.lastInventoryDetailsDate || this.selectDate || moment(this.current).format('DD MMM YYYY');
    if (this.daysheetStatus) {
      this.daysheetStatusByDate.set(dateKey, this.daysheetStatus.toUpperCase());
    }

    const scenarioList = this.getScenarioBasedMenuItemsListFromInventory(inv);
    if (scenarioList.length) {
      const fromApi = this.normalizeScenarioBasedMenuItemsList(scenarioList);
      if (this.isMenuCardSubmittedForCurrentDate() && this.hasActiveMenuSelection()) {
        this.scenarioBasedMenuItemsList = this.mergeScenarioMenuListsPreservingLocalMenu(
          this.scenarioBasedMenuItemsList,
          fromApi,
        );
      } else if (!this.hasActiveMenuSelection()) {
        this.scenarioBasedMenuItemsList = fromApi;
      } else {
        const apiHasActiveMenu = this.hasActiveMenuInScenarioList(fromApi);
        if (apiHasActiveMenu) {
          this.scenarioBasedMenuItemsList = fromApi;
        }
      }
    } else if (!this.isMenuCardSubmittedForCurrentDate() || !this.hasActiveMenuSelection()) {
      this.scenarioBasedMenuItemsList = [];
      if (!this.isMenuCardSubmittedForCurrentDate()) {
        this.menuAllowedMeals = this.emptyMenuAllowedMeals();
        this.menuAllowedScenarioIds.clear();
        this.menuAllowedMealsLockedFromSubmit = false;
      }
    }

    if (Array.isArray(inv.supplyBuildings) && inv.supplyBuildings.length > 0) {
      this.BuildingDetails = inv.supplyBuildings.map((r: any) => ({
        ...r,
        scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
        studentCount: Number(r.studentCount ?? 0),
        employeeCount: Number(r.employeeCount ?? 0),
        subStaffCount: Number(r.subStaffCount ?? 0),
        visitorsCount: Number(r.visitorsCount ?? 0),
      }));
    } else if (!this.isSupplyBuildingSubmittedForCurrentDate()) {
      this.BuildingDetails = [];
    }

    this.syncMenuCardSubmittedForDateFromInventory();
  }

  private mergeInventoryDetailsFromServer(): void {
    const inv = this.inventroyData;
    if (!inv || typeof inv !== 'object') {
      this.isDaysheetSubmitDisabled = false;
      if (!this.hasActiveMenuSelection()) {
        this.scenarioBasedMenuItemsList = [];
      }
      this.refreshInventoryEditableCells();
      return;
    }

    this.applyInventoryMetaFromServer();

    const details = this.collectSaveInventoryBalanceDetails(inv);
    if (Array.isArray(details) && details.length && Array.isArray(this.rowData) && this.rowData.length) {
      const byId = new Map<number, any>();
      details.forEach((d: any) => {
        const id = Number(d?.itemId);
        if (Number.isFinite(id)) byId.set(id, d);
      });
      this.rowData = this.rowData.map((row: any) => {
        const d = byId.get(Number(row.itemId));
        if (!d) return this.normalizeInventoryRow(row);
        const merged: any = {
          ...row,
          bfQty: Number(d.bfQty ?? row.bfQty ?? 0),
          lunchQty: Number(d.lunchQty ?? row.lunchQty ?? 0),
          snacksQty: Number(d.snacksQty ?? row.snacksQty ?? 0),
          DinnerQty: Number(d.dinnerQty ?? d.DinnerQty ?? row.DinnerQty ?? 0),
          ratePerUnit: Number(d.ratePerUnit ?? row.ratePerUnit ?? 0),
          itemStatus: String(d.itemStatus ?? row.itemStatus ?? '1'),
        };
        if (merged.itemStatus === '0') {
          merged.bfQty = 0;
          merged.lunchQty = 0;
          merged.snacksQty = 0;
          merged.DinnerQty = 0;
        }
        const n = this.normalizeInventoryRow(merged);
        const totalQty =
          Number(n.bfQty ?? 0) +
          Number(n.lunchQty ?? 0) +
          Number(n.snacksQty ?? 0) +
          Number(n.DinnerQty ?? 0);
        const openBal = Number(row?.openBalance ?? 0);
        const rate = Number(n.ratePerUnit ?? 0);
        n.totalQty = totalQty;
        n.totalAmount = Number((totalQty * rate).toFixed(2));
        n.closedBalance = Number((openBal - totalQty).toFixed(2));
        return n;
      });
    }

    this.syncMealColumnAccessFromMenu();
    // Preserve in-progress meal qty entries after server merge (ItemList / inventory details)
    this.applyStoredMealQtyFromDataStore();
    this.refreshInventoryEditableCells();
  }

  private getScenarioBasedMenuItemsListFromInventory(inv: any): any[] {
    const list = inv?.ScenarioBasedMenuItemsList ?? inv?.scenarioBasedMenuItemsList;
    return Array.isArray(list) ? list : [];
  }

  private normalizeScenarioBasedMenuItemsList(rawList: any[]): ScenarioBasedMenuItemPayload[] {
    return rawList
      .map((scenario) => ({
        scenarioId: Number(scenario?.scenarioId),
        scenarioName: String(scenario?.scenarioName ?? '').trim(),
        daysheetMenuItemsList: this.normalizeDaysheetMenuItemsList(scenario?.daysheetMenuItemsList),
        saveInventoryBalanceDetails:
          scenario?.saveInventoryBalanceDetails ?? scenario?.SaveInventoryBalanceDetails ?? [],
      }))
      .filter((scenario) => Number.isFinite(scenario.scenarioId) && !!scenario.scenarioName);
  }

  private normalizeDaysheetMenuItemsList(rawList: unknown): {
    daysheetMenuItemName: string;
    daysheetMenuItemId: number;
    status?: string;
    itemStatus?: string;
  }[] {
    if (!Array.isArray(rawList)) {
      return [];
    }
    return rawList
      .map((item: any) => {
        const status = String(item?.status ?? '1').trim() || '1';
        return {
          daysheetMenuItemId: Number(item?.daysheetMenuItemId ?? item?.DaysheetMenuItemId),
          daysheetMenuItemName: String(item?.daysheetMenuItemName ?? item?.DaysheetMenuItemName ?? '').trim(),
          status,
          itemStatus: String(item?.itemStatus ?? status).trim() || status,
        };
      })
      .filter((item) => Number.isFinite(item.daysheetMenuItemId) && !!item.daysheetMenuItemName);
  }

  private collectSaveInventoryBalanceDetails(inv: any): any[] {
    const scenarioList = this.getScenarioBasedMenuItemsListFromInventory(inv);
    if (!scenarioList.length) {
      return Array.isArray(inv?.saveInventoryBalanceDetails) ? inv.saveInventoryBalanceDetails : [];
    }

    const byItemId = new Map<number, any>();
    scenarioList.forEach((scenario) => {
      const details = scenario?.saveInventoryBalanceDetails ?? scenario?.SaveInventoryBalanceDetails;
      if (!Array.isArray(details)) {
        return;
      }
      details.forEach((d: any) => {
        const id = Number(d?.itemId);
        if (!Number.isFinite(id)) {
          return;
        }
        const existing = byItemId.get(id);
        if (!existing) {
          byItemId.set(id, {
            ...d,
            itemStatus: String(d?.itemStatus ?? '1'),
            bfQty: Number(d?.bfQty ?? 0),
            lunchQty: Number(d?.lunchQty ?? 0),
            snacksQty: Number(d?.snacksQty ?? 0),
            dinnerQty: Number(d?.dinnerQty ?? d?.DinnerQty ?? 0),
          });
          return;
        }
        if (Number(d?.bfQty ?? 0) > 0) {
          existing.bfQty = Number(d.bfQty);
        }
        if (Number(d?.lunchQty ?? 0) > 0) {
          existing.lunchQty = Number(d.lunchQty);
        }
        if (Number(d?.snacksQty ?? 0) > 0) {
          existing.snacksQty = Number(d.snacksQty);
        }
        const dinnerQty = Number(d?.dinnerQty ?? d?.DinnerQty ?? 0);
        if (dinnerQty > 0) {
          existing.dinnerQty = dinnerQty;
        }
        existing.ratePerUnit = Number(d?.ratePerUnit ?? existing.ratePerUnit ?? 0);
        existing.itemStatus = String(d?.itemStatus ?? existing.itemStatus ?? '1');
      });
    });
    return Array.from(byItemId.values());
  }

  private refreshInventoryEditableCells(): void {
    this.gridApi?.refreshCells({
      columns: ['itemName', 'bfQty', 'lunchQty', 'snacksQty', 'DinnerQty'],
      force: true,
    });
    this.syncMealQtyInputsInDom();
  }

  private syncMealQtyInputsInDom(): void {
    if (!this.gridApi) {
      return;
    }
    this.gridApi.forEachNode((node) => {
      if (node.rowPinned || !node.data) {
        return;
      }
      const openBal = Number(node.data?.openBalance ?? 0);
      MEAL_QTY_FIELDS.forEach((field) => {
        const input = document.querySelector(
          `input[data-inv-row-id="${String(node.id)}"][data-meal-qty="${field}"]`,
        ) as HTMLInputElement | null;
        if (!input) {
          return;
        }
        const enabled = this.isMealQtyInputEnabled(field) && openBal > 0;
        input.disabled = !enabled;
        if (!enabled) {
          input.style.cursor = 'not-allowed';
          input.style.backgroundColor = '#f3f4f6';
          input.style.border = openBal === 0 ? '2px solid red' : '1px solid #e5e7eb';
          return;
        }
        input.style.cursor = '';
        input.style.backgroundColor = '';
        input.style.border = '1px solid #ddd';
      });
    });
  }



  private loadDaysheetStatus(): void {
    return;
  }

  private maybeOpenHolidayReasonDialog(dateKey: string): void {
    const entry = this.daysheetHolidayByDate.get(dateKey);
    if (!entry?.holiday) {
      return;
    }
    const reason = String(entry.holidayReason ?? '').trim();
    this.zone.run(() => {
      this.matDialog.open(HolidayReasonViewDialogComponent, {
        width: '420px',
        maxWidth: '92vw',
        autoFocus: false,
        restoreFocus: true,
        data: { dateLabel: dateKey, reason },
      });
    });
  }


  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

  ItemList() {
    this.gridApi?.showLoadingOverlay();
    // this.spinner.show();
    this.service.regularItems(this.userbuildingId).subscribe({
      next: (res: any) => {
        if (!res || res == 204) {
          this.spinner.hide();
          this.showInventoryNoRowsOverlay();
          this.rowData = [];
        }
        // this.rowData = res;
        this.rowData = Array.isArray(res) ? res.map((r: any) => this.normalizeInventoryRow(r)) : [];
        this.mergeInventoryDetailsFromServer();
        // Keep entered Breakfast/Lunch/Snacks/Dinner from BehaviorSubject across ItemList reload
        this.applyStoredMealQtyFromDataStore();
        this.updatePinnedBottomRow();
        this.gridApi?.setGridOption?.('rowData', this.rowData as any);
        console.log('res', res);
        this.gridApi?.hideOverlay();
        this.spinner.hide();
        this.refreshMealQtyGridCells();
      },
      error: (err: any) => {
        this.spinner.hide();
        this.gridApi?.hideOverlay();
      }
    })
  }

  // 24/04/2026//
  /** Normalize meal qty defaults and numeric fields when loading rows */
  private normalizeInventoryRow(row: any): any {
    const n = (v: any) => {
      const x = Number(v);
      return Number.isFinite(x) ? x : 0;
    };
    const bfQty = n(row?.bfQty);
    const lunchQty = n(row?.lunchQty);
    const snacksQty = n(row?.snacksQty);
    const DinnerQty = n(row?.DinnerQty);
    const openBalance = n(row?.openBalance);
    const totalQty = bfQty + lunchQty + snacksQty + DinnerQty;
    const out: any = {
      ...row,
      bfQty,
      lunchQty,
      snacksQty,
      DinnerQty,
      totalQty
    };
    if (totalQty === 0) {
      out.totalAmount = 0;
      out.closedBalance = openBalance;
    }
    return out;
  }

  // ✅ Only totalAmount in pinned bottom row
  updatePinnedBottomRow(): void {
    // CellRenderer input handlers are native DOM listeners and may run outside Angular.
    // Ensure pinned total updates are applied inside Angular change detection.
    this.zone.run(() => {
      const totalAmount = this.rowData.reduce(
        (s: number, r: any) => s + Number(r.totalAmount ?? 0), 0
      );
      this.totalAmountValue = totalAmount;
      this.pinnedBottomRowData = [{
        itemName: 'Total',
        openBalance: null,
        bfQty: null,
        lunchQty: null,
        snacksQty: null,
        DinnerQty: null,
        totalQty: null,
        ratePerUnit: null,
        totalAmount: totalAmount, // ✅ only this shows
        closedBalance: null,
      }];
    });
  }

  /** Refresh only computed columns so meal-qty inputs are not torn down (Tab / Enter focus works). */
  private refreshInventoryDerivedColumns(params: any): void {
    params.api.refreshCells({
      rowNodes: [params.node],
      columns: ['totalQty', 'totalAmount', 'closedBalance'],
      force: true,
    });
  }

  /**
   * Shared meal qty commit (used on blur and on Tab/Enter).
   * Mutates row data + refreshes derived columns only (avoids re-rendering meal inputs mid-keydown).
   * @returns true if values were applied; false if validation failed (caller should not advance focus).
   */
  applyMealQtyChange(
    params: any,
    field: MealQtyField,
    rawText: string,
    inputEl: HTMLInputElement | null,
  ): boolean {
    if (this.isInventoryGridReadOnly()) {
      return false;
    }
    if (!this.isMealQtyInputEnabled(field)) {
      this.toast.showError('Please select Menu card');
      if (inputEl) {
        const prev = (params.node.data as any)?.[field];
        inputEl.value = prev === null || prev === undefined || prev === '' ? '0' : String(prev);
      }
      return false;
    }
    const openBal = Number(params.data?.openBalance ?? 0);
    const trimmed = String(rawText ?? '').trim();
    const val = parseFloat(trimmed);

    if (isNaN(val) || trimmed === '') {
      alert('❌ Please enter numbers only');
      if (inputEl) {
        const prev = (params.node.data as any)?.[field];
        inputEl.value = this.formatMealQtyInputDisplay(prev);
      }
      return false;
    }

    if (val < 0) {
      alert('❌ Consumed Qty must be greater than or equal to 0');
      if (inputEl) {
        const prev = (params.node.data as any)?.[field];
        inputEl.value = this.formatMealQtyInputDisplay(prev);
      }

      return false;
    }

    const d = params.node.data as any;
    d[field] = val;

    const breakfast = Number(d?.bfQty ?? 0);
    const lunch = Number(d?.lunchQty ?? 0);
    const snacksQty = Number(d?.snacksQty ?? 0);
    const dinnerQty = Number(d?.DinnerQty ?? 0);
    const totalQty = breakfast + lunch + snacksQty + dinnerQty;

    if (totalQty > openBal) {
      this.showOpenBalanceExceededDialog(totalQty, openBal);

      d[field] = 0;
      const updatedBreakfast = Number(d?.bfQty ?? 0);
      const updatedLunch = Number(d?.lunchQty ?? 0);
      const updatedSnacks = Number(d?.snacksQty ?? 0);
      const updatedDinner = Number(d?.DinnerQty ?? 0);
      const validTotal = updatedBreakfast + updatedLunch + updatedSnacks + updatedDinner;

      const ratePerUnit = Number(d?.ratePerUnit ?? 0);
      const totalAmount = validTotal * ratePerUnit;
      const closingBal = openBal - validTotal;

      d.totalAmount = Number(totalAmount.toFixed(2));
      d.closedBalance = Number(closingBal.toFixed(2));

      this.persistMealQtyToDataStore(d);
      this.refreshInventoryDerivedColumns(params);
      if (inputEl) inputEl.value = this.formatMealQtyInputDisplay(0);
      this.updatePinnedBottomRow();
      return false;
    }

    const ratePerUnit = Number(d?.ratePerUnit ?? 0);
    const totalAmount = totalQty * ratePerUnit;
    const closingBal = openBal - totalQty;

    d.totalAmount = Number(totalAmount.toFixed(2));
    d.closedBalance = Number(closingBal.toFixed(2));

    this.persistMealQtyToDataStore(d);
    this.refreshInventoryDerivedColumns(params);
    if (inputEl) {
      inputEl.value = this.formatMealQtyInputDisplay(d[field]);
    }
    this.updatePinnedBottomRow();
    return true;
  }

  /** Empty when qty is 0 so placeholder "0" shows in meal-qty inputs. */
  private formatMealQtyInputDisplay(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const n = Number(value);
    if (!Number.isFinite(n) || n === 0) {
      return '';
    }
    return String(value);
  }

  private isMealQtyControlCombo(e: KeyboardEvent): boolean {
    return e.ctrlKey || e.metaKey;
  }

  private isMealQtyAllowedNonDigitKey(e: KeyboardEvent): boolean {
    const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab', 'Enter'];
    return allowed.includes(e.key) || this.isMealQtyControlCombo(e);
  }

  /** After a successful commit, move focus along bf → lunch → snacks → dinner → next row bf (Shift+Tab / Shift+Enter backward). */
  private moveMealQtyFocusAfterCommit(
    params: any,
    field: MealQtyField,
    input: HTMLInputElement,
    delta: number,
  ): void {
    (input as any).__mealSkipBlur = true;
    const rowId = String(params.node.id);
    const order = MEAL_QTY_FIELDS as readonly string[];
    const idx = order.indexOf(field);
    const moveFocus = () => {
      const nextIdx = idx + delta;
      if (nextIdx >= 0 && nextIdx < order.length) {
        const next = document.querySelector(
          `input[data-inv-row-id="${rowId}"][data-meal-qty="${order[nextIdx]}"]`,
        ) as HTMLInputElement;
        next?.focus();
        return;
      }
      if (delta === 1) {
        const allBf: HTMLInputElement[] = [];
        document.querySelectorAll('input[data-meal-qty="bfQty"]').forEach((el) => allBf.push(el as HTMLInputElement));
        const cur = allBf.findIndex((el) => el.getAttribute('data-inv-row-id') === rowId);
        if (cur >= 0 && cur + 1 < allBf.length) {
          allBf[cur + 1].focus();
        }
        return;
      }
      const allDn: HTMLInputElement[] = [];
      document.querySelectorAll('input[data-meal-qty="DinnerQty"]').forEach((el) => allDn.push(el as HTMLInputElement));
      const curD = allDn.findIndex((el) => el.getAttribute('data-inv-row-id') === rowId);
      if (curD > 0) {
        allDn[curD - 1].focus();
      }
    };
    requestAnimationFrame(() => requestAnimationFrame(moveFocus));
  }

  /** Tab / Enter: commit then move to next meal input in the same row (Enter always forward). */
  handleMealQtyKeydown(e: KeyboardEvent, input: HTMLInputElement, field: MealQtyField, params: any): void {
    if (e.key === 'Tab' || e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      const rawForCommit = input.value.trim() === '' ? '0' : input.value;
      const committed = this.applyMealQtyChange(params, field, rawForCommit, input);
      if (!committed) {
        return;
      }
      input.value = this.formatMealQtyInputDisplay((params.node.data as any)?.[field]);
      const delta = e.key === 'Enter' ? 1 : e.shiftKey ? -1 : 1;
      this.moveMealQtyFocusAfterCommit(params, field, input, delta);
      return;
    }

    if (this.isMealQtyAllowedNonDigitKey(e)) return;
    if (/^[0-9]$/.test(e.key)) return;
    if (e.key === '.') return;
    e.preventDefault();
  }

  /** Allow digits and a single decimal point (e.g. 30.5); strips other characters and extra dots. */
  private sanitizeMealQtyInput(el: HTMLInputElement): void {
    let v = el.value.replace(/[^0-9.]/g, '');
    const dot = v.indexOf('.');
    if (dot !== -1) {
      v = v.slice(0, dot + 1) + v.slice(dot + 1).replace(/\./g, '');
    }
    if (el.value !== v) el.value = v;
  }

  /**
   * Live totals while typing: updates row data and refreshes only derived columns so the
   * focused meal input is not destroyed (avoids losing focus).
   */
  private syncLiveMealTotalsFromInput(params: any, field: MealQtyField, input: HTMLInputElement): void {
    if (this.isInventoryGridReadOnly() || !this.isMealQtyInputEnabled(field)) {
      return;
    }
    this.sanitizeMealQtyInput(input);
    const d = params.node.data as any;
    const raw = input.value.trim();
    if (raw !== '' && isNaN(parseFloat(raw))) {
      return;
    }
    const curNum = raw === '' ? 0 : parseFloat(raw);
    const bf = field === 'bfQty' ? curNum : Number(d?.bfQty ?? 0);
    const lunch = field === 'lunchQty' ? curNum : Number(d?.lunchQty ?? 0);
    const snacks = field === 'snacksQty' ? curNum : Number(d?.snacksQty ?? 0);
    const dinner = field === 'DinnerQty' ? curNum : Number(d?.DinnerQty ?? 0);
    const openBal = Number(d?.openBalance ?? 0);
    const totalQty = bf + lunch + snacks + dinner;
    if (totalQty > openBal) {
      const prevVal = Number(d?.[field] ?? 0);
      this.showOpenBalanceExceededDialog(totalQty, openBal);
      input.value = this.formatMealQtyInputDisplay(prevVal);
      return;
    }
    const rate = Number(d?.ratePerUnit ?? 0);
    d.bfQty = bf;
    d.lunchQty = lunch;
    d.snacksQty = snacks;
    d.DinnerQty = dinner;
    d.totalAmount = Number((totalQty * rate).toFixed(2));
    d.closedBalance = Number((openBal - totalQty).toFixed(2));
    this.persistMealQtyToDataStore(d);
    params.api.refreshCells({
      rowNodes: [params.node],
      columns: ['totalQty', 'totalAmount', 'closedBalance'],
      force: true,
    });
    this.updatePinnedBottomRow();
  }

  /** Persist Breakfast / Lunch / Snacks / Dinner qty into DataStoreService BehaviorSubject. */
  private persistMealQtyToDataStore(row: any): void {
    if (row?.itemId == null || row?.itemId === '') {
      return;
    }
    this.dataStore.setMealQtyForItem({
      itemId: row.itemId,
      bfQty: Number(row?.bfQty ?? 0),
      lunchQty: Number(row?.lunchQty ?? 0),
      snacksQty: Number(row?.snacksQty ?? 0),
      DinnerQty: Number(row?.DinnerQty ?? 0),
    });
  }

  /**
   * Re-apply entered meal qtys from DataStore BehaviorSubject onto grid rows.
   * Does not clear the store — ItemList / inventory merge must keep user-entered values.
   */
  private applyStoredMealQtyFromDataStore(): void {
    const stored = this.dataStore.getMealQtySnapshot();
    if (!stored.length || !Array.isArray(this.rowData) || !this.rowData.length) {
      return;
    }
    const byId = new Map(stored.map((s) => [String(s.itemId), s]));
    let changed = false;
    this.rowData = this.rowData.map((row: any) => {
      const s = byId.get(String(row?.itemId));
      if (!s) {
        return row;
      }
      changed = true;
      const bfQty = Number(s.bfQty ?? 0);
      const lunchQty = Number(s.lunchQty ?? 0);
      const snacksQty = Number(s.snacksQty ?? 0);
      const DinnerQty = Number(s.DinnerQty ?? 0);
      const openBal = Number(row?.openBalance ?? 0);
      const rate = Number(row?.ratePerUnit ?? 0);
      const totalQty = bfQty + lunchQty + snacksQty + DinnerQty;
      return {
        ...row,
        bfQty,
        lunchQty,
        snacksQty,
        DinnerQty,
        totalQty,
        totalAmount: Number((totalQty * rate).toFixed(2)),
        closedBalance: Number((openBal - totalQty).toFixed(2)),
      };
    });
    if (changed) {
      this.rowData = [...this.rowData];
    }
  }

  /** Shared cell renderer for Breakfast / Lunch / Snacks / Dinner qty: Tab order + calculations. */
  mealQtyCellRenderer(params: any, field: MealQtyField): HTMLElement | string {
    if (params.node.rowPinned) {
      return '';
    }
    const input = document.createElement('input');
    input.type = 'text';
    input.inputMode = 'decimal';
    input.autocomplete = 'off';
    input.placeholder = '0';
    input.className = 'mess-inventory-meal-qty-input';
    input.value = this.formatMealQtyInputDisplay(params.value);
    input.style.width = '100%';
    input.style.padding = '0px 4px';
    input.style.fontSize = '14px';
    input.style.textAlign = 'right';
    input.style.height = '30px';
    input.style.borderRadius = '4px';
    input.style.border = '1px solid #ddd';
    input.setAttribute('data-inv-row-id', String(params.node.id));
    input.setAttribute('data-meal-qty', field);

    if (this.isInventoryGridReadOnly() || !this.isMealQtyInputEnabled(field)) {
      input.disabled = true;
      input.style.cursor = 'not-allowed';
      input.style.backgroundColor = '#f3f4f6';
      input.style.border = '1px solid #e5e7eb';
    } else if ((params.data.openBalance ?? 0) === 0) {
      input.disabled = true;
      input.style.border = '2px solid red';
    }

    input.addEventListener('click', (e) => e.stopPropagation());

    input.addEventListener('keydown', (e: KeyboardEvent) =>
      this.handleMealQtyKeydown(e, input, field, params),
    );

    input.addEventListener('input', () => {
      this.syncLiveMealTotalsFromInput(params, field, input);
    });

    input.addEventListener('blur', () => {
      if ((input as any).__mealSkipBlur) {
        (input as any).__mealSkipBlur = false;
        return;
      }
      const raw = input.value.trim() === '' ? '0' : input.value;
      const committed = this.applyMealQtyChange(params, field, raw, input);
      if (committed) {
        input.value = this.formatMealQtyInputDisplay((params.node.data as any)?.[field]);
      }
    });

    input.tabIndex = 0;
    params.eGridCell.tabIndex = -1;
    params.eGridCell.addEventListener('focus', () => input.focus());

    input.addEventListener('focus', (e: Event) => {
      const t = e.target as HTMLInputElement;
      const val = t.value;
      setTimeout(() => t.setSelectionRange(val.length, val.length));
    });

    return input;
  }
  // 24/04/2026

  focusSearchInput() {
    setTimeout(() => {
      if (this.searchInputcampus) {
        this.searchInputcampus.nativeElement.focus();
      }
    }, 100);
  }

  // campusSearch(item: any) {
  //   this.buildingValue = (item.target as HTMLInputElement).value;
  //   if (this.buildingValue) {
  //     this.filteredCampusDetails = this.allocatedCampusList.filter((building: any) =>
  //       building.buildingName.includes(this.buildingValue) ||
  //       building.buildingName.toLowerCase().includes(this.buildingValue.toLowerCase())
  //     );
  //   } else {
  //     this.filteredCampusDetails = this.allocatedCampusList;
  //   }
  // }


  onstudentMeals(e: any) {
    console.log(e, 'e');
  }

  onfilterChange(event: any) {
    this.quickFilter = event.target.value;
  }

  onItemNameLangChange(): void {
    this.gridApi?.refreshCells({ columns: ['itemName'], force: true });
  }

  private findInventoryItemContext(itemId: number): {
    scenarioId: number;
    scenarioName: string;
    daysheetId?: number;
    itemStatus?: string;
    detail?: any;
  } | null {
    const inv = this.inventroyData;
    const list = this.getScenarioBasedMenuItemsListFromInventory(inv);
    for (const scenario of list) {
      const details = scenario?.saveInventoryBalanceDetails ?? scenario?.SaveInventoryBalanceDetails ?? [];
      const detail = (Array.isArray(details) ? details : []).find(
        (d: any) => Number(d?.itemId) === Number(itemId),
      );
      if (detail) {
        return {
          scenarioId: Number(scenario.scenarioId),
          scenarioName: String(scenario.scenarioName ?? '').trim(),
          daysheetId: Number(inv?.daysheetId),
          itemStatus: String(detail.itemStatus ?? '1'),
          detail,
        };
      }
    }
    return null;
  }

  /** Open same right-side dialog as Next(), in item mode: image 150×150 + meal qty inputs. */
  openItemQtyDialog(node: any): void {
    if (!node || node.rowPinned || !node?.data) {
      return;
    }
    if (this.isInventoryGridReadOnly()) {
      return;
    }
    if (!this.isRegularItemsAllowed()) {
      this.toast.showError('Please select Menu card');
      return;
    }
    // AG Grid cellRenderer uses native DOM click — run inside Angular zone so dialog content renders.
    this.zone.run(() => {
      const dialogRef = this.dialog.open(AdminSingleAdditemComponent, {
        width: '30%',
        height: '100%',
        data: {
          mode: 'item',
          row: { ...node.data },
          buildingId: this.userbuildingId,
          currentDate: this.selectDate || moment(this.current).format('DD MMM YYYY'),
          daysheetId: this.inventroyData?.daysheetId,
          inventoryItemContext: this.findInventoryItemContext(Number(node.data?.itemId)),
          itemNameDisplayLang: this.itemNameDisplayLang,
          onInventoryUpdated: () => this.getInventoryDetails(),
        },
        panelClass: 'mess-inventory-right-dialog',
        position: { right: '0px' },
        animation: { to: 'left' },
        maxWidth: '100%',
        autoFocus: false,
        restoreFocus: false,
        disableClose: true,
        hasBackdrop: true,
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        if (!res || res.mode !== 'item') {
          return;
        }
        if (res.removed || res.saved) {
          return;
        }
        this.applyDialogQuantitiesToRow(res);
      });
    });
  }

  private showOpenBalanceExceededDialog(totalQty: number, openBal: number): void {
    const openDialog = () => {
      this.matDialog.open(ConfirmationMessageDialogComponent, {
        width: '400px',
        maxWidth: '92vw',
        autoFocus: false,
        restoreFocus: true,
        data: {
          title: 'Open Balance Exceeded',
          message: `Total Consumed (${totalQty}) cannot exceed Open Balance (${openBal}).`,
          confirmLabel: 'OK',
          confirmResult: 'ok',
          singleAction: true,
        },
      });
    };
    this.zone.run(openDialog);
  }

  private applyDialogQuantitiesToRow(q: any): void {
    const idx = this.rowData.findIndex((r: any) => Number(r?.itemId) === Number(q.itemId));
    if (idx < 0) {
      return;
    }
    const row = this.rowData[idx];
    const openBal = Number(row?.openBalance ?? 0);
    const bf = Number(q.bfQty ?? 0);
    const lunch = Number(q.lunchQty ?? 0);
    const snacks = Number(q.snacksQty ?? 0);
    const dinner = Number(q.DinnerQty ?? 0);
    const totalQty = bf + lunch + snacks + dinner;
    if (totalQty > openBal) {
      this.toast.showError(`Total consumed (${totalQty}) cannot exceed Open Balance (${openBal}).`);
      this.showOpenBalanceExceededDialog(totalQty, openBal);
      return;
    }
    this.zone.run(() => {
      row.bfQty = bf;
      row.lunchQty = lunch;
      row.snacksQty = snacks;
      row.DinnerQty = dinner;
      const rate = Number(row.ratePerUnit ?? 0);
      row.totalAmount = Number((totalQty * rate).toFixed(2));
      row.closedBalance = Number((openBal - totalQty).toFixed(2));
      this.persistMealQtyToDataStore(row);
      this.rowData = [...this.rowData];
      this.gridApi?.refreshCells({ force: true });
      this.updatePinnedBottomRow();
    });
  }


  colDefs: ColDef[] = [

    {
      headerName: 'S.No',
      pinned: 'left',
      width: 70,
      cellStyle: { 'text-align': 'center', 'font-size': '16px' },
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      valueGetter: (params: any) => params.node.rowIndex + 1, // ✅ 1, 2, 3...
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return '';
        return params.value;
      }
    },
    {
      field: 'itemName',
      headerName: 'Item Name',
      pinned: 'left',
      width: 350,
      cellStyle: { 'text-align': 'left', 'font-size': '16px', color: 'rgb(24 64 121)', 'font-weight': '500' },
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;

        // ✅ pinned bottom row — show "Total : <total cost>" in Item Name column
        if (params.node.rowPinned) {
          const bold = document.createElement('strong');
          bold.innerText = 'Total : ' + this.inrGroupedNumber(params.data?.totalAmount);
          bold.style.color = '#0b3f78';
          bold.style.fontSize = '14px';
          return bold;
        }
        const fusionItemId = params.data?.itemFusionId;
        const imageUrl = fusionItemId
          ? `http://mess-images.s3.ap-south-1.amazonaws.com/medium/${fusionItemId}.jpg`
          : null;

        // ✅ wrapper div — flex row (click opens item qty dialog)
        const wrapper = document.createElement('div');
        wrapper.style.display = 'flex';
        wrapper.style.alignItems = 'center';
        wrapper.style.gap = '8px';
        wrapper.style.height = '100%';
        wrapper.style.color = '#FFA50A';
        if (!this.isInventoryGridReadOnly()) {
          wrapper.style.cursor = 'pointer';
          wrapper.addEventListener('click', (ev: MouseEvent) => {
            ev.stopPropagation();
            this.openItemQtyDialog(params.node);
          });
        }

        // ✅ image or placeholder
        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          const displayLabel =
            this.itemNameDisplayLang === 'te'
              ? String(params.data?.teluguItemName ?? params.value ?? '')
              : String(params.data?.itemName ?? params.value ?? '');
          img.alt = displayLabel;
          img.style.width = '35px';
          img.style.height = '35px';
          img.style.borderRadius = '4px';
          img.style.objectFit = 'cover';
          img.style.flexShrink = '0';

          // ✅ fallback if image not found
          img.onerror = () => {
            img.style.display = 'none';
          };

          wrapper.appendChild(img);
        }

        // ✅ item name text (English or Telugu from dropdown)
        const span = document.createElement('span');
        span.innerText =
          this.itemNameDisplayLang === 'te'
            ? String(params.data?.teluguItemName ?? params.value ?? '')
            : String(params.data?.itemName ?? params.value ?? '');
        span.style.color = 'rgb(24 64 121)';
        span.style.overflow = 'hidden';
        span.style.textOverflow = 'ellipsis';
        span.style.whiteSpace = 'nowrap';
        wrapper.appendChild(span);

        return wrapper;
      }
    },

    {
      field: 'itemFusionId',
      headerName: 'Fusion Id',
      pinned: 'left',
      width: 150,
      hide: false,
      // filter: 'agTextColumnFilter',
      cellStyle: { 'text-align': 'left', 'font-size': '16px' },
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return ''; // ✅ hide
        return params.value;
      }
    },

    {
      field: 'openBalance',
      headerName: 'Open Balance Qty',
      width: 150,
      minWidth: 150,
      maxWidth: 170,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-inventory-header-center',
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return ''; // ✅ hide
        return this.inrGroupedNumber(params.value);
      }
    },
    {
      field: 'bfQty',
      headerName: 'Breakfast Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'bfQty'),
      headerClass: 'mess-inventory-header-center',



    },
    {
      field: 'lunchQty',
      headerName: 'Lunch Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'lunchQty'),
      headerClass: 'mess-inventory-header-center',
    },
    {
      field: 'snacksQty',
      headerName: 'Snacks Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'snacksQty'),
      headerClass: 'mess-inventory-header-center',
    },
    {
      field: 'DinnerQty',
      headerName: 'Dinner Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      suppressKeyboardEvent: (p) => p.event.key === 'Tab' || p.event.key === 'Enter',
      cellRenderer: (params: any) => this.mealQtyCellRenderer(params, 'DinnerQty'),
      headerClass: 'mess-inventory-header-center',
    },

    // TotalQty //

    {
      colId: 'totalQty',
      headerName: 'Total Qty',
      width: 120,
      minWidth: 110,
      maxWidth: 130,
      valueGetter: (p) => {
        const d = p.data;
        if (!d) return 0;
        return (
          Number(d.bfQty ?? 0) +
          Number(d.lunchQty ?? 0) +
          Number(d.snacksQty ?? 0) +
          Number(d.DinnerQty ?? 0)
        );
      },
      valueFormatter: (p) => this.inrGroupedNumber(p.value),
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-inventory-header-center',
      suppressKeyboardEvent: () => true,
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return ''; // ✅ hide
        const d = params.data;
        const sum =
          Number(d?.bfQty ?? 0) +
          Number(d?.lunchQty ?? 0) +
          Number(d?.snacksQty ?? 0) +
          Number(d?.DinnerQty ?? 0);
        return this.inrGroupedNumber(sum);
      },
    },

    {
      field: 'ratePerUnit',
      headerName: 'Rate (₹)',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      headerClass: 'mess-inventory-header-center',
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return '';
        return this.inrGroupedNumber(params.value);
      }
    },

    {
      colId: 'totalAmount',
      field: 'totalAmount',
      headerName: 'Total Cost (₹)',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-inventory-header-center',
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) {
          return '';
        }
        return this.inrGroupedNumber(params.value);
      }
    },

    {
      field: 'closedBalance',
      headerName: 'Closed Balance Qty',
      width: 180,
      minWidth: 180,
      maxWidth: 200,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'mess-inventory-header-center',
      valueFormatter: (params) => this.inrGroupedNumber(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        if (params.node.rowPinned) return '';
        return this.inrGroupedNumber(params.value);
      }
    },
  ];


  rowData: PeriodicElement2[] = [];
  pinnedBottomRowData: any[] = [];
  // pinnedTopRowData: PeriodicElement2[] = [];

  defaultColDef: ColDef = {
    flex: 1,
    menuTabs: [],
    suppressHeaderMenuButton: true,
    sortable: true,
    filter: false,
    headerClass: 'mess-inventory-header-center',
  };

  // ✅ custom overlay text
  overlayLoadingTemplate = `
  <span class="ag-overlay-loading-center">
    Please wait while data is loading...
  </span>`;

  overlayNoRowsTemplate = `
  <span>No data found</span>`;

  private getNoRowsOverlayTemplate(): string {
    if (!this.isRegularItemsAllowed()) {
      return `<span>Please add Menu card to load inventory items</span>`;
    }
    return `<span>No data found</span>`;
  }

  private showInventoryNoRowsOverlay(): void {
    this.overlayNoRowsTemplate = this.getNoRowsOverlayTemplate();
    this.gridApi?.setGridOption?.('overlayNoRowsTemplate', this.overlayNoRowsTemplate);
    this.gridApi?.showNoRowsOverlay();
  }

  onCellValueChanged(event: CellValueChangedEvent<PeriodicElement2>) {
    const editableFields = ['bfQty', 'lunchQty', 'snacksQty', 'DinnerQty', 'ratePerUnit'];
    if (!editableFields.includes(event.colDef.field!)) return;

    const openBal = Number(event.data?.openBalance ?? 0);
    const ratePerUnit = Number(event.data?.ratePerUnit ?? 0);

    // Get all entered quantities
    const breakfast = Number(event.data?.bfQty ?? 0);
    const lunch = Number(event.data?.lunchQty ?? 0);
    const snacks = Number(event.data?.snacksQty ?? 0);
    const dinner = Number(event.data?.DinnerQty ?? 0);

    const totalQty = breakfast + lunch + snacks + dinner;

    // 🚨 If totalQty exceeds openBalance, show alert but continue
    if (totalQty > openBal) {
      alert(`⚠️ Warning: Total Consumed (${totalQty}) exceeds Open Balance (${openBal}).`);
      return;
    }

    // ✅ Calculate totals regardless
    const totalAmount = totalQty * ratePerUnit;
    const closedBalance = openBal - totalQty;

    // Update the calculated fields
    event.node.setDataValue('totalAmount', totalAmount.toFixed(2));
    event.node.setDataValue('closedBalance', closedBalance.toFixed(2));

    if (MEAL_QTY_FIELDS.includes(event.colDef.field! as MealQtyField)) {
      this.persistMealQtyToDataStore(event.data);
    }

    // Refresh UI
    event.api.refreshCells({ rowNodes: [event.node], force: true });
    this.updatePinnedBottomRow();

    // console.log(
    //   `Updated | totalQty=${totalQty}, totalAmount=${totalAmount}, closedBalance=${closedBalance}`
    // );
  }

  /**
   * Utility: formats numbers without decimals
   */
  // numFmt(value: any): string {
  //   if (value === null || value === undefined || value === '') return '';
  //   const n = Number(value);
  //   if (isNaN(n)) return '';
  //   return n.toString(); // plain integer
  // }
  // 👉 GRID OPTIONS to control tabbing

  /** Commit focused meal-qty inputs and sync live grid row data into rowData before submit. */
  private flushMealQtyFromGrid(): void {
    if (!this.gridApi) {
      return;
    }
    this.gridApi.forEachNode((node) => {
      if (node.rowPinned || !node.data) {
        return;
      }
      const d = node.data as any;
      MEAL_QTY_FIELDS.forEach((field) => {
        const input = document.querySelector(
          `input[data-inv-row-id="${String(node.id)}"][data-meal-qty="${field}"]`,
        ) as HTMLInputElement | null;
        if (!input || input.disabled) {
          return;
        }
        const trimmed = input.value.trim();
        if (trimmed === '' || isNaN(parseFloat(trimmed))) {
          return;
        }
        d[field] = parseFloat(trimmed);
      });
      const bf = Number(d.bfQty ?? 0);
      const lunch = Number(d.lunchQty ?? 0);
      const snacks = Number(d.snacksQty ?? 0);
      const dinner = Number(d.DinnerQty ?? 0);
      const totalQty = bf + lunch + snacks + dinner;
      const openBal = Number(d.openBalance ?? 0);
      const rate = Number(d.ratePerUnit ?? 0);
      d.totalQty = totalQty;
      d.totalAmount = Number((totalQty * rate).toFixed(2));
      d.closedBalance = Number((openBal - totalQty).toFixed(2));
    });
    this.syncRowDataFromGrid();
  }

  private syncRowDataFromGrid(): void {
    if (!this.gridApi) {
      return;
    }
    const liveById = new Map<number, any>();
    this.gridApi.forEachNode((node) => {
      if (node.rowPinned || !node.data) {
        return;
      }
      const id = Number((node.data as any).itemId);
      if (Number.isFinite(id)) {
        liveById.set(id, node.data);
      }
    });
    const merged: any[] = [];
    const seen = new Set<number>();
    (this.rowData ?? []).forEach((row) => {
      const id = Number(row.itemId);
      const live = Number.isFinite(id) ? liveById.get(id) : null;
      merged.push(live ?? row);
      if (Number.isFinite(id)) {
        seen.add(id);
      }
    });
    liveById.forEach((data, id) => {
      if (!seen.has(id)) {
        merged.push(data);
      }
    });
    this.rowData = merged;
  }

  private getMealQtyFromRowOrFallback(
    row: any,
    fallback: any,
    field: 'bfQty' | 'lunchQty' | 'snacksQty' | 'DinnerQty',
  ): number {
    const fromRow = Number(row?.[field]);
    if (Number.isFinite(fromRow) && fromRow > 0) {
      return fromRow;
    }
    if (field === 'DinnerQty') {
      return Number(fallback?.dinnerQty ?? fallback?.DinnerQty ?? 0);
    }
    return Number(fallback?.[field] ?? 0);
  }

  openTotalSummary(): void {
    this.totalSummaryData = this.buildTotalSummaryData();
    this.initSummaryScenarioExpanded();
    this.buildAllSummaryRows();
    this.summaryViewMode = 'all';
    this.showTotalSummary = true;
  }

  closeTotalSummary(): void {
    this.showTotalSummary = false;
    this.summaryScenarioExpanded = {};
  }

  setSummaryViewMode(mode: 'all' | 'summary'): void {
    this.summaryViewMode = mode;
  }

  /** Merge every scenario's inventory rows into one table (keyed by item) for the "All" view. */
  private buildAllSummaryRows(): void {
    const scenarios = this.totalSummaryData?.scenarioBasedMenuItemsList ?? [];
    const merged = new Map<string, any>();

    for (const scenario of scenarios) {
      for (const item of scenario?.saveInventoryBalanceDetails ?? []) {
        const key = String(item?.itemId ?? item?.itemName ?? '').trim();
        if (!key) continue;
        const existing = merged.get(key);
        if (!existing) {
          merged.set(key, {
            ...item,
            bfQty: Number(item?.bfQty ?? 0),
            lunchQty: Number(item?.lunchQty ?? 0),
            snacksQty: Number(item?.snacksQty ?? 0),
            dinnerQty: Number(item?.dinnerQty ?? item?.DinnerQty ?? 0),
          });
        } else {
          existing.bfQty += Number(item?.bfQty ?? 0);
          existing.lunchQty += Number(item?.lunchQty ?? 0);
          existing.snacksQty += Number(item?.snacksQty ?? 0);
          existing.dinnerQty += Number(item?.dinnerQty ?? item?.DinnerQty ?? 0);
        }
      }
    }

    this.allSummaryRows = Array.from(merged.values()).map((row: any) => {
      const totalQty = row.bfQty + row.lunchQty + row.snacksQty + row.dinnerQty;
      const totalCost = Number((totalQty * Number(row?.ratePerUnit ?? 0)).toFixed(2));
      return { ...row, totalQty, totalCost };
    });

    this.allSummaryTotalCost = Number(
      this.allSummaryRows.reduce((sum, row) => sum + Number(row.totalCost ?? 0), 0).toFixed(2),
    );
  }

  /** Closed Qty = On Hand Qty − Total Qty (same rule as the inventory grid). */
  getSummaryClosedQty(item: any): number {
    const openQty = Number(item?.onHandQty ?? item?.openBalance ?? 0);
    const totalQty = Number(item?.totalQty ?? 0);
    if (!Number.isFinite(openQty) || !Number.isFinite(totalQty)) {
      return 0;
    }
    return Number((openQty - totalQty).toFixed(2));
  }

  /** "Today's Menu" lines for the All view: scenario name + its active menu item names. */
  getTodaysMenuList(): Array<{ scenarioName: string; menuItems: string }> {
    const scenarios = this.totalSummaryData?.scenarioBasedMenuItemsList ?? [];
    return scenarios.map((scenario: any) => ({
      scenarioName: String(scenario?.scenarioName ?? '').trim(),
      menuItems: this.getSummaryMenuLabel(scenario),
    }));
  }

  /** Column header for a scenario's own meal qty in the Summary view (e.g. "Breakfast Qty"). */
  getScenarioMealQtyLabel(scenario: any): string {
    const qtyField = this.getScenarioMealQtyField(String(scenario?.scenarioName ?? ''));
    switch (qtyField) {
      case 'bfQty': return 'Breakfast Qty';
      case 'lunchQty': return 'Lunch Qty';
      case 'snacksQty': return 'Snacks Qty';
      default: return 'Dinner Qty';
    }
  }

  /** Item qty for the scenario's own meal column in the Summary view. */
  getScenarioMealQtyValue(scenario: any, item: any): number {
    const qtyField = this.getScenarioMealQtyField(String(scenario?.scenarioName ?? ''));
    if (qtyField === 'DinnerQty') {
      return Number(item?.dinnerQty ?? item?.DinnerQty ?? 0);
    }
    return Number(item?.[qtyField] ?? 0);
  }

  goBack(): void {
    if (this.router.url.includes('MessDetails')) {
      this.service.clearAdminMessInventoryParams();
      this.service.setView('adminDivisionReport');
      return;
    }
    this.location.back();
  }

  get totalSummaryPerHeadPrice(): number {
    const data = this.totalSummaryData;
    if (!data) {
      return 0;
    }
    const heads =
      Number(data.studentCount ?? 0) +
      Number(data.employeeCount ?? 0) +
      Number(data.subStaffCount ?? 0) +
      Number(data.visitorsCount ?? 0);
    const total = Number(data.daysheetAmount ?? 0);
    if (!heads || heads <= 0) {
      return 0;
    }
    return Number((total / heads).toFixed(2));
  }

  isSummaryScenarioExpanded(scenario: any): boolean {
    const key = this.getSummaryScenarioKey(scenario);
    return this.summaryScenarioExpanded[key] ?? false;
  }

  toggleSummaryScenarioExpand(scenario: any): void {
    const key = this.getSummaryScenarioKey(scenario);
    this.summaryScenarioExpanded[key] = !this.isSummaryScenarioExpanded(scenario);
  }

  private initSummaryScenarioExpanded(): void {
    this.summaryScenarioExpanded = {};
    const scenarios = this.totalSummaryData?.scenarioBasedMenuItemsList ?? [];
    for (const scenario of scenarios) {
      const key = this.getSummaryScenarioKey(scenario);
      this.summaryScenarioExpanded[key] = this.isBreakfastSummaryScenario(scenario);
    }
  }

  private getSummaryScenarioKey(scenario: any): string {
    const id = String(scenario?.scenarioId ?? '').trim();
    if (id) {
      return id;
    }
    return String(scenario?.scenarioName ?? '').trim().toLowerCase();
  }

  private isBreakfastSummaryScenario(scenario: any): boolean {
    const name = String(scenario?.scenarioName ?? '').trim().toLowerCase();
    return name.includes('breakfast') || Number(scenario?.scenarioId) === 13;
  }

  getSummaryMenuLabel(scenario: any): string {
    return this.getActiveSummaryMenuItems(scenario)
      .map((item: any) => item.daysheetMenuItemName)
      .filter((name: string) => !!name)
      .join(', ') || '—';
  }

  getActiveSummaryMenuItems(scenario: any): any[] {
    return (scenario?.daysheetMenuItemsList ?? []).filter(
      (item: any) => String(item?.status ?? item?.itemStatus ?? '1') !== '0',
    );
  }

  getScenarioSummaryTotalCost(scenario: any): number {
    return (scenario?.saveInventoryBalanceDetails ?? []).reduce(
      (sum: number, item: any) => sum + Number(item?.totalCost ?? 0),
      0,
    );
  }

  private buildTotalSummaryData(): any {
    const payload = this.preparePayload();
    const inv = this.inventroyData ?? {};
    const scenarioBasedMenuItemsList = (payload.scenarioBasedMenuItemsList ?? []).map((scenario: any) => ({
      ...scenario,
      saveInventoryBalanceDetails: (scenario.saveInventoryBalanceDetails ?? []).map((item: any) =>
        this.normalizeScenarioSummaryInventoryItem(scenario.scenarioName, item),
      ),
    }));

    return {
      daysheetId: inv.daysheetId ?? null,
      studentCount: payload.studentCount,
      employeeCount: payload.employeeCount,
      subStaffCount: payload.subStaffCount,
      visitorsCount: payload.visitorsCount,
      status: payload.status,
      daysheetAmount: payload.daysheetAmount,
      scenarioBasedMenuItemsList,
      supplyBuildings: payload.supplyBuildings,
    };
  }

  /** Summary view only: each scenario row shows qty in its meal column, others as 0. */
  private normalizeScenarioSummaryInventoryItem(scenarioName: string, item: any): any {
    const qtyField = this.getScenarioMealQtyField(scenarioName);
    const scenarioQty =
      qtyField === 'DinnerQty'
        ? Number(item?.dinnerQty ?? item?.DinnerQty ?? 0)
        : Number(item?.[qtyField] ?? 0);
    const ratePerUnit = Number(item?.ratePerUnit ?? 0);
    const totalQty = scenarioQty;

    return {
      ...item,
      bfQty: qtyField === 'bfQty' ? scenarioQty : 0,
      lunchQty: qtyField === 'lunchQty' ? scenarioQty : 0,
      snacksQty: qtyField === 'snacksQty' ? scenarioQty : 0,
      dinnerQty: qtyField === 'DinnerQty' ? scenarioQty : 0,
      totalQty,
      totalCost: Number((totalQty * ratePerUnit).toFixed(2)),
    };
  }

  preparePayload() {
    this.flushMealQtyFromGrid();
    const inv = this.inventroyData ?? {};
    const payload: any = {
      buildingId: this.userbuildingId,
      inventoryDate: this.selectDate || moment(this.current).format("DD MMM YYYY"),
      studentCount: this.totalStudents,
      employeeCount: this.totalEmployee,
      subStaffCount: this.totalSubStaff,
      visitorsCount: this.totalVisitors,
      status: String(inv.status ?? this.daysheetStatus ?? 'PENDING').trim() || 'PENDING',
      daysheetAmount: this.totalAmountValue,
      supplyBuildings: this.BuildingDetails.map((r: any) => ({
        supplyId: r.supplyId,
        supplyBuildingName: r.supplyBuildingName,
        scaitsStudentCount: this.resolveScaitsStudentCountForPayload(r),
        studentCount: Number(r.studentCount ?? 0),
        employeeCount: Number(r.employeeCount ?? 0),
        subStaffCount: Number(r.subStaffCount ?? 0),
        visitorsCount: Number(r.visitorsCount ?? 0),
      })),
      scenarioBasedMenuItemsList: this.scenarioBasedMenuItemsList.map((scenario) => ({
        scenarioId: String(scenario.scenarioId),
        scenarioName: scenario.scenarioName,
        daysheetMenuItemsList: (scenario.daysheetMenuItemsList ?? [])
          .map((item) => {
            const status = String(item.status ?? item.itemStatus ?? '1');
            const daysheetMenuItemName = String(
              item.daysheetMenuItemName ??
                (item as { DaysheetMenuItemName?: string }).DaysheetMenuItemName ??
                '',
            ).trim();
            return {
              daysheetMenuItemId: Number(item.daysheetMenuItemId),
              daysheetMenuItemName,
              status,
              itemStatus: String(item.itemStatus ?? status),
            };
          })
          .filter((item) => Number.isFinite(item.daysheetMenuItemId) && !!item.daysheetMenuItemName),
        saveInventoryBalanceDetails: this.buildScenarioSaveInventoryBalanceDetails(scenario),
      })),
    };

    return payload;
  }

  private buildScenarioSaveInventoryBalanceDetails(scenario: ScenarioBasedMenuItemPayload): any[] {
    const qtyField = this.getScenarioMealQtyField(scenario.scenarioName);
    const stored = scenario.saveInventoryBalanceDetails;
    const storedIds = new Set(
      (Array.isArray(stored) ? stored : [])
        .map((d: any) => Number(d?.itemId))
        .filter((id) => Number.isFinite(id)),
    );

    const buildDetail = (
      row: any,
      fallback?: any,
      options?: { scenarioOnlyQty?: boolean },
    ): any | null => {
      const itemId = Number(row?.itemId ?? fallback?.itemId);
      if (!Number.isFinite(itemId)) {
        return null;
      }
      const bfQty = Number(row?.bfQty ?? fallback?.bfQty ?? 0);
      const lunchQty = Number(row?.lunchQty ?? fallback?.lunchQty ?? 0);
      const snacksQty = Number(row?.snacksQty ?? fallback?.snacksQty ?? 0);
      const dinnerQty = Number(row?.DinnerQty ?? fallback?.dinnerQty ?? fallback?.DinnerQty ?? 0);
      const totalQty = bfQty + lunchQty + snacksQty + dinnerQty;
      const scenarioQty = this.getMealQtyFromRowOrFallback(row, fallback, qtyField);
      const itemStatus = String(row?.itemStatus ?? fallback?.itemStatus ?? '1');
      if (itemStatus === '0') {
        return null;
      }
      const scenarioOnlyQty = options?.scenarioOnlyQty ?? false;
      if (scenarioOnlyQty) {
        if (!scenarioQty || scenarioQty <= 0) {
          return null;
        }
      } else if (totalQty <= 0) {
        return null;
      }
      const ratePerUnit = Number(row?.ratePerUnit ?? fallback?.ratePerUnit ?? 0);
      return {
        itemId,
        itemName: String(row?.itemName ?? row?.name ?? fallback?.itemName ?? '').trim(),
        ratePerUnit,
        bfQty: scenarioOnlyQty ? (qtyField === 'bfQty' ? scenarioQty : 0) : bfQty,
        lunchQty: scenarioOnlyQty ? (qtyField === 'lunchQty' ? scenarioQty : 0) : lunchQty,
        snacksQty: scenarioOnlyQty ? (qtyField === 'snacksQty' ? scenarioQty : 0) : snacksQty,
        dinnerQty: scenarioOnlyQty ? (qtyField === 'DinnerQty' ? scenarioQty : 0) : dinnerQty,
        totalQty: Number(fallback?.totalQty ?? totalQty),
        itemFusionId: row?.itemFusionId ?? fallback?.itemFusionId,
        onHandQty: Number(fallback?.onHandQty ?? row?.onHandQty ?? row?.openBalance ?? 0),
        itemStatus,
      };
    };

    if (Array.isArray(stored) && stored.length) {
      const fromStored = stored
        .map((d: any) => {
          const row = (this.rowData ?? []).find((item: any) => Number(item.itemId) === Number(d.itemId));
          return buildDetail(row ?? d, d, { scenarioOnlyQty: false });
        })
        .filter((item) => item != null) as any[];

      const fromNewRows = (this.rowData ?? [])
        .map((item: any) => {
          const itemId = Number(item?.itemId);
          if (!Number.isFinite(itemId) || storedIds.has(itemId)) {
            return null;
          }
          return buildDetail(item, undefined, { scenarioOnlyQty: true });
        })
        .filter((item) => item != null) as any[];

      return [...fromStored, ...fromNewRows];
    }

    return (this.rowData ?? [])
      .map((item: any) => buildDetail(item, undefined, { scenarioOnlyQty: true }))
      .filter((item) => item != null) as any[];
  }

  private getScenarioMealQtyField(scenarioName: string): 'bfQty' | 'lunchQty' | 'snacksQty' | 'DinnerQty' {
    const name = String(scenarioName ?? '').trim().toLowerCase();
    if (name.includes('breakfast')) {
      return 'bfQty';
    }
    if (name.includes('lunch')) {
      return 'lunchQty';
    }
    if (name.includes('snack')) {
      return 'snacksQty';
    }
    if (name.includes('dinner')) {
      return 'DinnerQty';
    }
    return 'bfQty';
  }

  submit() {
    // if (this.isDaysheetSubmitDisabled || this.isHolidayBlockingActions()) {
    //   return;
    // }
    // ✅ Validate head count (at least one of the counts must be entered)
    // const heads =
    //   Number(this.totalStudents ?? 0) +
    //   Number(this.totalEmployee ?? 0) +
    //   Number(this.totalSubStaff ?? 0) +
    //   Number(this.totalVisitors ?? 0);
    // if (!heads || heads <= 0) {
    //   this.toast.showError('Please enter Student / Employee / SubStaff / Visitors count before submitting.');
    //   return;
    // }
    // ✅ Validate consumed quantities (at least one of the meal qty must be entered)
    // const consumedQty =
    //   (this.rowData ?? []).reduce((sum: number, r: any) => {
    //     const bf = Number(r?.bfQty ?? 0);
    //     const lunch = Number(r?.lunchQty ?? 0);
    //     const snacks = Number(r?.snacksQty ?? 0);
    //     const dinner = Number(r?.DinnerQty ?? 0);
    //     return sum + bf + lunch + snacks + dinner;
    //   }, 0);
    // if (!consumedQty || consumedQty <= 0) {
    //   this.toast.showError('Please enter Breakfast / Lunch / Snacks / Dinner quantity before submitting.');
    //   return;
    // }
    const hasMenuSelection = (this.scenarioBasedMenuItemsList ?? []).some((scenario) =>
      (scenario.daysheetMenuItemsList ?? []).some((item) => String(item.status ?? '1') !== '0'),
    );
    if (!hasMenuSelection) {
      this.toast.showError('Please select menu card');
      return;
    }
     // ✅ Validate head count (at least one of the counts must be entered)
    const heads =
      Number(this.totalStudents ?? 0) +
      Number(this.totalEmployee ?? 0) +
      Number(this.totalSubStaff ?? 0) +
      Number(this.totalVisitors ?? 0);
    if (!heads || heads <= 0) {
      this.toast.showError('Please enter Student / Employee / SubStaff / Visitors count before submitting.');
      return;
    }
    // ✅ Validate consumed quantities (at least one of the meal qty must be entered)
    const consumedQty =
      (this.rowData ?? []).reduce((sum: number, r: any) => {
        const bf = Number(r?.bfQty ?? 0);
        const lunch = Number(r?.lunchQty ?? 0);
        const snacks = Number(r?.snacksQty ?? 0);
        const dinner = Number(r?.DinnerQty ?? 0);
        return sum + bf + lunch + snacks + dinner;
      }, 0);
    if (!consumedQty || consumedQty <= 0) {
      this.toast.showError('Please enter Breakfast / Lunch / Snacks / Dinner quantity before submitting.');
      return;
    }
    // Clear stored meal qty when Total Summary (sbd__btn) proceeds
    this.dataStore.clearMealQty();
    this.openTotalSummary();
  }

  confirmDaysheetSubmit(): void {
    if (this.isDaysheetSubmitDisabled || this.isHolidayBlockingActions()) {
      return;
    }
    // Clear stored meal qty when Daysheet Submit (sbd__btn) is clicked
    this.dataStore.clearMealQty();
    const confirmRef = this.dialog.open(DaysheetcloseConfirmationMessageDialogComponent, {
      width: '400px',
      maxWidth: '92vw',
      autoFocus: false,
      restoreFocus: true,
      data: {
        title: 'Daysheet Close',
        message: 'Are you sure you want to close this daysheet?',
      },
    });
    confirmRef.afterClosed().subscribe((result) => {
      if (result === 'daysheetClose') {
        this.postDaysheetSubmit();
      }
    });
  }

  private postDaysheetSubmit(): void {
    const payload = this.preparePayload();
    console.log('payload', payload);
    this.spinner.show();
    this.service.adminUpdateClosedInventory(payload).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return
        }
        this.toast.showSuccess(res.message);
        this.getInventoryDetails();
        console.log('res', res);
        this.closeTotalSummary();

        this.spinner.hide();
      },
      error: (err: any) => {
        this.toast.showError(err.error.message);
        this.spinner.hide();
      }
    })
  }

  addItem() {
    if (this.isDaysheetSubmitDisabled || this.isHolidayBlockingActions()) {
      return;
    }
    if (!this.isRegularItemsAllowed()) {
      this.toast.showError('Please select Menu card');
      return;
    }
    const dialogRef = this.dialog.open(AddItemDialogComponent, {
      width: '30%',
      height: '100%',
      data: {
        buildingId: this.userbuildingId,
        existingItems: this.rowData
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((selected: any) => {
      if (!selected) return;

      const openBal = Number(selected?.openBalance ?? 0);
      if (!openBal) {
        return; // don't add items with zero open balance
      }

      const selectedItemId = selected?.itemId;
      if (selectedItemId && this.rowData?.some((x: any) => x?.itemId === selectedItemId)) {
        this.toast.showError('Item already exists');
        return; // already exists, don't duplicate
      }
      const newRow: any = {
        itemId: selected?.itemId ?? null,
        itemName: selected?.itemName ?? selected?.name ?? '',
        openBalance: openBal,
        bfQty: 0,
        lunchQty: 0,
        snacksQty: 0,
        DinnerQty: 0,
        ratePerUnit: selected?.ratePerUnit ?? 0,
        totalAmount: 0,
        closedBalance: selected?.closedBalance ?? 0,
        itemStatus: '1',
      };
      this.rowData = [...(this.rowData ?? []), newRow];
      this.gridApi?.setGridOption?.('rowData', this.rowData as any);
      this.updatePinnedBottomRow(); // ✅ refresh after add
      console.log('row data', this.rowData);
    });

  }

  /** Indian digit grouping (no currency symbol) */
  inrGroupedNumber(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(String(value).replace(/,/g, ''));
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(n);
  }

  /** Indian digit grouping with ₹ prefix (symbol side by side with value). */
  inrCurrencyGrouped(value: any): string {
    const formatted = this.inrGroupedNumber(value);
    if (!formatted) return '';
    return `₹${formatted}`;
  }

  /**
  * Utility: formats numbers (legacy name; uses Indian grouping)
  */
  numFmt(value: any): string {
    return this.inrGroupedNumber(value);
  }

  Next() {
    this.openMessSummaryDialog();
  }

  openMessSummaryDialog(): void {
    const supplyBuildingsForDialog = this.resolveSupplyBuildingsForSummaryDialog();
    const restoreLocalSupplyBuildings = supplyBuildingsForDialog.length > 0;

    const dialogRef = this.dialog.open(MessSummaryDialogComponent, {
      width: '65%',
      height: '100%',
      data: {
        buildingId: this.userbuildingId,
        currentDate: this.selectDate || moment(this.current).format('DD MMM YYYY'),
        daysheetId: this.inventroyData?.daysheetId,
        totalAmountValue: this.totalAmountValue,
        restoreLocalSupplyBuildings,
        supplyBuildings: supplyBuildingsForDialog,
        readOnly: this.isDaysheetSubmitDisabled || this.isHolidayBlockingActions(),
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((selected: any) => {
      this.applySupplyBuildingsFromDialog(selected);
    });
  }

  private isSupplyBuildingSubmittedForCurrentDate(): boolean {
    const date = this.getActiveStockDate();
    return !!date && this.supplyBuildingSubmittedForDate === date;
  }

  /** Prefer getInventoryDetails supplyBuildings; else same-session dialog submit. */
  private resolveSupplyBuildingsForSummaryDialog(): any[] {
    const invBuildings = this.inventroyData?.supplyBuildings;
    if (Array.isArray(invBuildings) && invBuildings.length > 0) {
      return this.cloneSupplyBuildingsForDialog(invBuildings);
    }
    if (this.isSupplyBuildingSubmittedForCurrentDate() && Array.isArray(this.BuildingDetails) && this.BuildingDetails.length) {
      return this.cloneSupplyBuildingsForDialog(this.BuildingDetails);
    }
    return [];
  }

  private cloneSupplyBuildingsForDialog(rows?: any[]): any[] {
    return (rows ?? []).map((r: any) => ({
      supplyId: Number(r?.supplyId ?? 0),
      supplyBuildingName: String(r?.supplyBuildingName ?? '').trim(),
      scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
      studentCount: Number(r?.studentCount ?? 0),
      employeeCount: Number(r?.employeeCount ?? 0),
      subStaffCount: Number(r?.subStaffCount ?? 0),
      visitorsCount: Number(r?.visitorsCount ?? 0),
    }));
  }

  private applySupplyBuildingsFromDialog(selected: any): void {
    if (!selected || !Array.isArray(selected.supplyBuildings)) {
      return;
    }
    this.supplyBuildingSubmittedForDate = this.getActiveStockDate();
    this.BuildingDetails = selected.supplyBuildings.map((r: any) => ({
      ...r,
      scaitsStudentCount: this.toScaitsStudentCount(r?.scaitsStudentCount),
      studentCount: Number(r.studentCount ?? 0),
      employeeCount: Number(r.employeeCount ?? 0),
      subStaffCount: Number(r.subStaffCount ?? 0),
      visitorsCount: Number(r.visitorsCount ?? 0),
    }));
  }

  /** Keep API `scaitsStudentCount` (Student Strength) for summary dialog validation. */
  private toScaitsStudentCount(value: unknown): number | null {
    const n = Number(value ?? NaN);
    return Number.isFinite(n) && n >= 0 ? n : null;
  }

  /**
   * Payload always sends numeric `scaitsStudentCount` (e.g. 860).
   * Falls back to inventory API row by supplyId when local row is missing it.
   */
  private resolveScaitsStudentCountForPayload(row: any): number {
    const fromRow = this.toScaitsStudentCount(row?.scaitsStudentCount);
    if (fromRow != null) {
      return fromRow;
    }
    const supplyId = Number(row?.supplyId ?? NaN);
    const invRows = this.inventroyData?.supplyBuildings;
    if (Array.isArray(invRows) && Number.isFinite(supplyId)) {
      const match = invRows.find((x: any) => Number(x?.supplyId) === supplyId);
      const fromInv = this.toScaitsStudentCount(match?.scaitsStudentCount);
      if (fromInv != null) {
        return fromInv;
      }
    }
    return 0;
  }

  //25/04/2026 supply building //

  get totalCampus(): number {
    return this.BuildingDetails?.length ?? 0;
  }

  get totalHeadCount(): number {
    return this.BuildingDetails?.reduce((sum: number, r: any) =>
      sum +
      Number(r.studentCount ?? 0) +
      Number(r.employeeCount ?? 0) +
      Number(r.subStaffCount ?? 0) +
      Number(r.visitorsCount ?? 0), 0) ?? 0;
  }

  get perHeadPrice(): number {
    const heads = Number(this.totalHeadCount ?? 0);
    const total = Number(this.totalAmountValue ?? 0);
    if (!heads || heads <= 0) return 0;
    return Number((total / heads).toFixed(2));
  }


  get totalStudents(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.studentCount ?? 0), 0) ?? 0;
  }

  get totalEmployee(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.employeeCount ?? 0), 0) ?? 0;
  }

  get totalSubStaff(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.subStaffCount ?? 0), 0) ?? 0;
  }

  get totalVisitors(): number {
    return this.BuildingDetails?.reduce((s: number, r: any) => s + Number(r.visitorsCount ?? 0), 0) ?? 0;
  }

  //end Supply building //

  // menu card //

  private cloneScenarioMenuListForDialog(list: ScenarioBasedMenuItemPayload[]): ScenarioBasedMenuItemPayload[] {
    return (list ?? []).map((scenario) => ({
      scenarioId: Number(scenario.scenarioId),
      scenarioName: String(scenario.scenarioName ?? '').trim(),
      daysheetMenuItemsList: (scenario.daysheetMenuItemsList ?? []).map((item) => ({
        daysheetMenuItemId: Number(item.daysheetMenuItemId),
        daysheetMenuItemName: String(item.daysheetMenuItemName ?? '').trim(),
        status: String(item.status ?? item.itemStatus ?? '1'),
        itemStatus: String(item.itemStatus ?? item.status ?? '1'),
      })),
      saveInventoryBalanceDetails: Array.isArray(scenario.saveInventoryBalanceDetails)
        ? [...scenario.saveInventoryBalanceDetails]
        : [],
    }));
  }

  MenuCard(): void {
    const restoreLocalMenu =
      this.isMenuCardSubmittedForCurrentDate() && this.hasActiveMenuSelection();
    const dialogRef = this.dialog.open(AdminMenuDialogComponent, {
      width: '30%',
      height: '100%',
      data: {
        buildingId: this.userbuildingId,
        inventoryDate: this.selectDate || moment(this.current).format('DD MMM YYYY'),
        daysheetId: this.inventroyData?.daysheetId,
        restoreLocalMenu,
        scenarioBasedMenuItemsList: restoreLocalMenu
          ? this.cloneScenarioMenuListForDialog(this.scenarioBasedMenuItemsList)
          : [],
        daysheetStatus: this.daysheetStatus,
        isHoliday: this.isHolidayBlockingActions(),
        onInventoryUpdated: () => this.getInventoryDetails(),
      },
      panelClass: 'mess-inventory-right-dialog',
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((res: MenuDialogSubmitResult | undefined) => {
      if (!res?.menuSubmitted || !res.scenarioBasedMenuItemsList) {
        return;
      }
      this.menuCardSubmittedForDate = this.getActiveStockDate();
      this.scenarioBasedMenuItemsList = this.mergeSubmittedScenarioMenuList(
        this.scenarioBasedMenuItemsList,
        res.scenarioBasedMenuItemsList,
      );
      console.log('menu-dialog merged scenarioBasedMenuItemsList', this.scenarioBasedMenuItemsList);
      this.applyMenuSubmitAccess(res);
      if (!this.isInventoryGridReadOnly()) {
        this.loadRegularItemsIfAllowed();
      }
      this.refreshMealQtyGridCells();
    });
  }
  
  getSummaryMenuItemCount(scenario: any): number {
    return this.getActiveSummaryMenuItems(scenario).length;
  }

}
